<template>
  <f7-page name="control-planificacion">
    <!-- #1133 · el nombre sale de la misma clave que la entrada del menú lateral, para que el
         menú, su buscador, la tarjeta y esta cabecera digan lo mismo: «ACEL PLANIFICACIÓN». -->
    <f7-navbar :title="$t('main_menu.controlplanificacion')" :back-link="$t('atras')"></f7-navbar>
    <!-- #16 · Se agrega en la propia peticion sobre reparto-ejec-lineas-pedidos: no hay cache detras. -->
    <div class="sello-datos-bar"><sello-datos estado="vivo" /></div>

    <!-- SPEC-DASHBOARD-CONTROL-PLANIFICACION: dashboard per mockup claude\dashboard-control-planificacion.html.
         Los filtros de cabecera actúan sobre TODO (KPIs + donut + barras + tabla): los dos endpoints
         (/agregados y /lineas) reciben el MISMO filtro.
         #544 · y el filtro de fechas «Desde»/«Hasta» va además a /anomalias, así que el rango alcanza
         también a las tres tarjetas, a los recuentos de los botones de estado y a su tabla: las tres
         llamadas de la pantalla reciben la MISMA ventana (ver `ventanaFechas`). -->
    <div class="cpd">
      <div class="hero">
        <div class="in">
          <div>
            <!-- #544 · aquí iba el rótulo «SIMECAL · ORGANISMO DE CONTROL». Lo retira Dirección
                 (17/10/2026) SOLO en esta pantalla; el título y el resto de la cabecera no se mueven. -->
            <div class="htitle">{{ $t('main_menu.controlplanificacion') }}</div>
            <!-- Ronda 1 de revisión de la #544 · esta línea es donde esta pantalla cuenta en qué
                 estado están los seis recuadros, el círculo y las barras (ya lo hacía con
                 «actualizando cifras…»), así que es donde tiene que decir que la última carga no
                 llegó y que lo que se sigue viendo es del filtro anterior. El aviso modal se cierra
                 y no deja rastro: sin esto, un cambio de rango que falla deja las cifras del rango
                 de antes sin nada que lo diga (§9 del CLAUDE.md del orquestador). -->
            <div class="hsub">Estado de todo lo planificado, lo planificable y lo bloqueado · {{ hoy }}<span v-if="cargandoAgg"> · actualizando cifras…</span><span class="hserr" v-else-if="avisoCifras"> · {{ avisoCifras }}</span></div>
          </div>
          <div class="hfilters">
            <!-- Los filtros de siempre, en el mismo sitio y en el mismo orden. La fila es un div
                 propio para que la nota del filtro de fechas tenga su línea debajo sin empujarlos. -->
            <div class="hfrow">
              <!-- FIX salto de scroll: blur del select (el foco provoca recolocación) + conservarScroll() -->
              <select class="sel" v-model="filtro.planificadora" @change="$event.target.blur(); recargar()">
                <option :value="null">Planificadora · Todas</option>
                <option v-for="p in opciones.planificadoras" :key="'pl-' + p" :value="p">{{ p }}</option>
              </select>
              <select class="sel" v-model="filtro.provincia" @change="$event.target.blur(); recargar()">
                <option :value="null">Provincia · Todas</option>
                <option v-for="p in opciones.provincias" :key="'pr-' + p" :value="p">{{ p }}</option>
              </select>
              <select class="sel" v-model="filtro.materia" @change="$event.target.blur(); recargar()">
                <option :value="null">Materia · Todas</option>
                <option v-for="m in opciones.materias" :key="'ma-' + m" :value="m">{{ m }}</option>
              </select>
              <select class="sel sel-hi" v-model="filtro.planificable" @change="$event.target.blur(); recargar()">
                <option :value="null">Planificable · Todos</option>
                <option value="SI">Planificable · Sí</option>
                <option value="NO">Planificable · No</option>
                <option value="VACIO">Planificable · vacío</option>
              </select>
              <!-- #544 · petición de Dirección (17/10/2026). Las dos fechas son INCLUSIVAS: el día que
                   se elige en «Hasta» se ve. Vacías = la pantalla se comporta igual que antes.
                   A propósito SIN `min`/`max` cruzados entre los dos: acotar el calendario de uno con
                   el valor del otro deja sin elegir un rango anterior al puesto —para bajar «Hasta»
                   habría que vaciar antes «Desde»— y el calendario no puede explicar por qué un día
                   está en gris. El rango al revés se deja escribir y se explica junto al control. -->
              <label class="fch" :class="{ mal: rangoInvalido }">Desde
                <input type="date" v-model="filtro.desdeStr" @change="$event.target.blur(); cambioFechas()">
              </label>
              <label class="fch" :class="{ mal: rangoInvalido }">Hasta
                <input type="date" v-model="filtro.hastaStr" @change="$event.target.blur(); cambioFechas()">
              </label>
            </div>
            <!-- La nota del filtro de fechas, SIEMPRE montada y pegada al control: dice por qué fecha
                 filtra (sin ella nadie puede saberlo), qué se queda fuera cuando hay rango, y qué pasa
                 cuando el rango está al revés. Un solo elemento para las tres cosas, para que no se
                 queden diciendo lo contrario y para que nada entre ni salga del layout (§9 del
                 CLAUDE.md del orquestador). El «Quitar fechas» vive AQUÍ y no en la fila de arriba a
                 propósito: la fila está justificada a la derecha y meterle un botón que aparece y
                 desaparece movería de sitio los cuatro filtros que ya había. -->
            <div class="hfnota" :class="{ mal: rangoInvalido }">{{ notaFechas }}<a class="fchclr"
                 v-if="rangoActivo" @click="limpiarFechas()">Quitar fechas</a></div>
          </div>
        </div>
      </div>

      <div class="wrap">
        <!-- KPIs -->
        <div class="kpis">
          <div class="kpi"><div class="k">Líneas en control</div><div class="v">{{ n(kpi.lineas) }}</div>
            <div class="d dmut">{{ agg.porPlanificadora.length }} planificadoras</div></div>
          <div class="kpi"><div class="k"><span class="dot" style="background:#2563EB"></span>Planificables</div>
            <div class="v">{{ n(kpi.planificables) }}</div><div class="d dmut">Planificable = Sí / vacío</div></div>
          <div class="kpi"><div class="k"><span class="dot" style="background:#0E9F6E"></span>Planificadas</div>
            <div class="v">{{ n(kpi.planificadas) }} <small>/ {{ n(kpi.planificables) }}</small></div>
            <div class="d up">{{ pct(kpi.planificadas, kpi.planificables) }}% del volumen</div></div>
          <div class="kpi"><div class="k"><span class="dot" style="background:#7C3AED"></span>Pendientes de planificar</div>
            <div class="v">{{ n(kpi.pendientes) }}</div><div class="d dmut">listas para el solver</div></div>
          <!-- #860 · una línea no planificable sale del reparto, no de la cartera (dirección, 22/10/2026):
               «apartadas» y no «bloqueados», porque su importe sigue dentro de «Importe en juego». -->
          <div class="kpi"><div class="k"><span class="dot" style="background:#B45309"></span>No planificables</div>
            <div class="v">{{ n(kpi.noPlanificables) }}</div>
            <div class="d warn">{{ eur(kpi.importeNoPlan) }}<template v-if="cartera"> · {{ horas(cartera.apartada.horas) }}</template> apartados</div>
            <div class="d dmut">fuera del reparto, no de la cartera</div></div>
          <!-- #860 · el total cuenta las apartadas y la bolsa apartada va AL LADO, con su importe y sus
               horas, junto a lo que queda sin ella: las tres cifras salen del mismo $facet y
               «sin apartadas» + «apartadas» = total. Nunca se resta en silencio (P16). -->
          <div class="kpi"><div class="k">Importe en juego</div>
            <div class="v">{{ eur(kpi.importe) }}</div>
            <div class="d dmut" v-if="cartera">{{ horas(cartera.total.horas) }} · {{ notaSinTiempo(cartera.total) }}</div>
            <div class="d dmut" v-else>líneas activas del filtro</div>
            <template v-if="cartera">
              <div class="d warn">incluye apartadas: {{ eur(cartera.apartada.importe) }} · {{ horas(cartera.apartada.horas) }}</div>
              <div class="d dmut">sin apartadas: {{ eur(cartera.sinApartada.importe) }} · {{ horas(cartera.sinApartada.horas) }}</div>
            </template></div>
        </div>

        <!-- fila: estado + est pla -->
        <div class="cols">
          <div class="panel">
            <div class="ph"><div class="t">Estado de la planificación</div><div class="s">{{ n(kpi.lineas) }} líneas</div></div>
            <div class="donutwrap">
              <div class="donut">
                <svg width="150" height="150" viewBox="0 0 42 42">
                  <circle cx="21" cy="21" r="15.9" fill="none" stroke="#EFEDF6" stroke-width="5.4"></circle>
                  <circle v-for="(s, i) in donutSegs" :key="'dn-' + i" cx="21" cy="21" r="15.9" fill="none"
                          :stroke="s.color" stroke-width="5.4" :stroke-dasharray="s.dash + ' 100'"
                          :stroke-dashoffset="s.offset" stroke-linecap="round"></circle>
                </svg>
                <div class="ctr"><div class="big">{{ pct(kpi.planificadas, kpi.planificables) }}%</div><div class="lbl">planificado</div></div>
              </div>
              <div class="leg">
                <div class="r" v-for="(s, i) in donutSegs" :key="'lg-' + i">
                  <span class="dot" :style="{ background: s.color }"></span>
                  <span class="nm">{{ s.nombre }}</span><span class="vv">{{ n(s.n) }}</span>
                  <span class="pc">{{ pct(s.n, kpi.lineas) }}%</span>
                </div>
              </div>
            </div>
          </div>

          <div class="panel">
            <div class="ph"><div class="t">No planificables por motivo</div><div class="s">campo EST PLA</div></div>
            <div class="bars">
              <div class="brow" v-for="b in barrasEstPla" :key="'ep-' + b.valor">
                <div class="bl">
                  <span class="nm"><span class="cc">{{ b.cc }}</span>{{ b.label }}</span>
                  <span class="am">{{ n(b.n) }} · <b>{{ eur(b.importe) }}</b></span>
                </div>
                <div class="track"><div class="fill" :style="{ width: b.pctBarra + '%' }"></div></div>
              </div>
              <div v-if="!barrasEstPla.length" class="vacio">Sin líneas etiquetadas con EST PLA en el filtro actual.</div>
            </div>
          </div>
        </div>

        <!-- fila: equipo + provincia -->
        <div class="cols">
          <div class="panel">
            <div class="ph"><div class="t">Reparto del equipo</div><div class="s">líneas por planificadora</div></div>
            <div class="team">
              <div class="tc" v-for="t in equipoTop" :key="'tm-' + t.nombre">
                <div class="av" :style="t.gris ? 'background:#94A3B8' : ''">{{ t.avatar }}</div>
                <div class="nm">{{ t.nombre }}</div><div class="n">{{ n(t.n) }} líneas</div>
              </div>
              <div v-if="!equipoTop.length" class="vacio">Sin planificadora informada.</div>
            </div>
          </div>
          <div class="panel">
            <div class="ph"><div class="t">Carga por provincia</div><div class="s">top 5</div></div>
            <div class="bars">
              <div class="brow" v-for="p in provinciasTop" :key="'pv-' + p.nombre">
                <div class="bl"><span class="nm">{{ p.nombre }}</span><span class="am"><b>{{ n(p.n) }}</b></span></div>
                <div class="track"><div class="fill teal" :style="{ width: p.pctBarra + '%' }"></div></div>
              </div>
            </div>
          </div>
        </div>

        <!-- aviso de ficha -->
        <div class="act" v-if="fichas.sinFicha > 0">
          <div class="i">⚙️</div>
          <div>
            <div class="t">Hay líneas planificables que el solver no coloca por ficha de inspector sin configurar</div>
            <!-- #544 · esta cifra no sale de las líneas: son los inspectores dados de alta frente a
                 las fichas configuradas, así que no hay fecha de ejecución por la que filtrarla. Con
                 un rango puesto se dice AQUÍ, al lado de la cifra, y no en silencio. -->
            <div class="m">{{ fichas.sinFicha }} de {{ fichas.inspectores }} inspectores sin ficha (base, radio o provincias) → complétalas para que entren en las propuestas.<span v-if="rangoAplicado"> Este recuento es de toda la plantilla: no se filtra por fechas.</span></div>
          </div>
          <button @click="irAFichas()">Configurar fichas</button>
        </div>

        <!-- TABLA interactiva -->
        <div class="tsec">
          <div class="tstop">
            <!-- #326: las cifras son las del conjunto ENTERO del filtro, y la nota dice qué parte se
                 está viendo. Antes aquí se rotulaba la longitud de la página (el front pide 300 y el
                 servidor topa en 500) como si fuera el total del filtro. -->
            <div class="t">{{ tituloTabla }} <small>{{ cifrasTabla }}</small>
              <div class="trunc" v-if="notaTabla">{{ notaTabla }}</div>
            </div>
            <div class="chips">
              <span class="chip" :class="{ on: !chipActivo }" @click="setChip(null)">Todos <span class="c">{{ n(totalChips) }}</span></span>
              <span class="chip" :class="{ on: chipActivo === b.valor }" v-for="b in chipsEstPla" :key="'ch-' + b.valor"
                    @click="setChip(b.valor)">{{ b.labelCorto }} <span class="c">{{ n(b.n) }}</span></span>
            </div>
          </div>
          <!-- #543 · la barra deja de aparecer solo con filas marcadas. «Exportar» tiene que poder
               usarse SIN selección (es ahí donde exporta el filtro entero), y esconder la barra lo
               hacía inalcanzable. Nada cambia de sitio: los tres botones siguen donde estaban y en
               el mismo orden; los dos que necesitan una selección se deshabilitan y dicen por qué
               A SU LADO, en vez de quedarse mudos (§9 del CLAUDE.md del orquestador). -->
          <div class="bulk on" :class="{ vacia: !seleccion.length }">
            <span class="n" v-if="seleccion.length">{{ seleccion.length }} seleccionada{{ seleccion.length === 1 ? '' : 's' }}</span>
            <span class="n" v-else>Ninguna línea seleccionada</span><span class="sp"></span>
            <span class="mot" v-if="!seleccion.length">marca alguna línea para reasignar o enviar a Incidencias</span>
            <button :disabled="!seleccion.length" @click="abrirReasignar()">Reasignar EST PLA</button>
            <button :disabled="exportando" @click="exportarCsv()">{{ textoExportar }}</button>
            <button class="primary" :disabled="!seleccion.length" @click="enviarIncidencias()">Enviar a Incidencias</button>
          </div>
          <div class="tscroll">
            <table>
              <thead><tr>
                <th style="width:34px"><input type="checkbox" class="chk" :checked="todoSeleccionado" @change="seleccionarTodo($event)"></th>
                <th>Pedido / línea</th><th>Cliente</th><th>Población</th><th>Materia</th><th>F.Rep.Ejec</th>
                <th>Importe</th><th>Motivo (EST PLA)</th><th>Apartada desde</th>
              </tr></thead>
              <tbody>
                <!-- #857 · «Comentario» e «Ir al pedido» bajan a una fila de acciones bajo cada línea: con
                     ellos como columnas la tabla no cabía a 1366 px y «Apartada desde» quedaba cortada. -->
                <template v-for="l in lineas">
                  <tr class="lin" :key="claveLinea(l)" :class="{ sel: estaSeleccionada(l) }">
                    <td><input type="checkbox" class="chk" :checked="estaSeleccionada(l)" @change="toggleLinea(l)"></td>
                    <td class="ped">{{ l.codigoPedido || l.numeroPedido }} <span class="li">· {{ l.numLinea }}</span></td>
                    <td><div class="cli">{{ l.cliente || '—' }}</div></td>
                    <td>{{ l.poblacion || '—' }}<div class="sub">{{ l.provincia || '' }}</div></td>
                    <td><span class="mat">{{ l.materia || '—' }}</span></td>
                    <td>{{ fecha(l.fRepEjec) }}</td>
                    <td class="price">{{ eur(l.importe) }}</td>
                    <td><span class="epla" :class="claseEstPla(l.estPlaValor)" v-if="l.estPlaValor">● {{ l.estPlaLabel || l.estPlaValor }}</span><span v-else class="sub">—</span></td>
                    <!-- #857 · desde cuándo y por quién. Sin fecha registrada se dice así, con el día del
                         despliegue como «al menos»: nunca se pinta esa referencia como fecha de apartado. -->
                    <td class="apd">
                      <template v-if="l.apartada">
                        <div :class="{ 'apd-sin': !l.apartadaDesdeRegistrada }">{{ textoApartadaDesde(l) }}</div>
                        <div class="sub apd-por">{{ textoApartadaPor(l) }}</div>
                        <div class="sub" v-if="l.diasApartada != null">{{ n(l.diasApartada) }} {{ l.diasApartada === 1 ? 'día' : 'días' }}</div>
                      </template>
                      <a v-if="l.historicoMotivos && l.historicoMotivos.length" class="apd-hist" @click="abrirHistorico(l)">Histórico ({{ l.historicoMotivos.length }})</a>
                    </td>
                  </tr>
                  <tr class="acc" :key="'acc-' + claveLinea(l)" :class="{ sel: estaSeleccionada(l) }">
                    <td></td>
                    <td colspan="8"><div class="acc-in">
                      <span class="com"><template v-if="l.estPlaNotas"><b>Comentario:</b> {{ l.estPlaNotas }}</template></span>
                      <a class="goped" :href="'/pedidos/view/' + l.idPedido + '/'">Ir al pedido →</a>
                    </div></td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <!-- FIX salto de scroll: pie SIEMPRE montado con altura fija (nada entra/sale del layout).
               El fallo de la última carga se cuenta AQUÍ, en la misma frase que cuenta lo que se
               enseña: las filas de antes siguen en pantalla y el pie dice de qué consulta son. -->
          <div class="foot">{{ cargando ? 'Cargando…'
            : (lineasError ? 'No se ha podido cargar la tabla: ' + lineasError
                + (lineas.length ? ' · se siguen viendo las líneas de la consulta anterior' : '')
            : (tablaVacia ? 'Sin líneas para el filtro actual.'
            : lineas.length + ' líneas mostradas')) }}</div>
        </div>

        <!-- PALANCA C FASE 2: Anomalías a revisar (maqueta anomalias-a-revisar.html). Ámbito GLOBAL
             adrede (control de deuda y saneamiento): NO sigue los filtros de cabecera del dashboard.
             #544 · con UNA excepción, la que pidió Dirección: el rango «Desde»/«Hasta» SÍ llega aquí,
             porque si no, las tarjetas y los recuentos de los botones de estado estarían contando otro
             conjunto que las cifras de arriba (§9 del CLAUDE.md del orquestador). El resto de los
             filtros de cabecera siguen fuera, y el rótulo del ámbito lo dice.
             #619 · y sin rango en la cabecera NO cuenta todo el histórico: el servidor aplica la
             ventana por defecto (últimos N años, configurable) y la sección dice cuál, junto a sus
             cifras, con lo que queda fuera. «Desde»/«Hasta» la sustituyen para llegar a lo anterior. -->
        <!-- Ronda 1 de revisión de la #543: `anomError` entra en la condición para que un fallo no
             haga desaparecer la sección entera de la pantalla. Antes, si la carga de un chip
             fallaba, se vaciaban las cifras, esto dejaba de cumplirse y no quedaba ni aviso ni forma
             de reintentar o de elegir otro chip: había que recargar la pantalla completa. -->
        <div class="tsec anomsec" v-if="anom || anomCargando || anomError">
          <div class="anhead">
            <span class="anbar"></span>
            <div class="t">⚠️ {{ $t('anomaliasRevisar.titulo') }}</div>
            <div class="anhint">{{ hintAnomalias }}</div>
          </div>
          <template v-if="anom">
            <p class="anlead">{{ $t('anomaliasRevisar.lead') }}</p>
            <div class="antiles">
              <div class="antile an-crit">
                <div class="ico">💶</div>
                <div class="lab">{{ $t('anomaliasRevisar.tileCobrado') }}</div>
                <div class="val">{{ n(anom.cobradoFacturadoSinRealizar.n) }}</div>
                <div class="sub">{{ $t('anomaliasRevisar.tileCobradoSub') }}</div>
                <div class="eurv">{{ eur(anom.cobradoFacturadoSinRealizar.importe) }}</div>
              </div>
              <div class="antile an-warn">
                <div class="ico">🔒</div>
                <div class="lab">{{ $t('anomaliasRevisar.tileSap') }}</div>
                <div class="val">{{ n(anom.cerradasSap.n) }}</div>
                <div class="sub">{{ $t('anomaliasRevisar.tileSapSub') }}</div>
                <div class="eurv">{{ $t('anomaliasRevisar.tileSapProponibles', { n: anom.cerradasSap.proponibles }) }}</div>
              </div>
              <div class="antile an-slate">
                <div class="ico">📋</div>
                <div class="lab">{{ $t('anomaliasRevisar.tileTotal') }}</div>
                <div class="val">{{ n(anom.total && anom.total.n) }}</div>
                <div class="sub">{{ $t('anomaliasRevisar.tileTotalSub') }}</div>
                <div class="eurv">{{ eur(anom.total && anom.total.importe) }}</div>
              </div>
            </div>
            <!-- #619 · qué ventana cuentan estas tres cifras y los botones de estado, y cuántas líneas
                 se quedan fuera. Va JUNTO a las cifras y no en el rótulo de arriba: una cifra acotada
                 que no dice que lo está se lee como el total (§9 del CLAUDE.md del orquestador). -->
            <div class="antrunc" v-if="notaVentanaAnomalias">{{ notaVentanaAnomalias }}</div>
            <!-- Ronda 1 de revisión de la #544 · las tarjetas y los recuentos de los chips son del
                 rango con el que se pidieron, y desde la #544 ese rango puede no ser el que está
                 puesto en la cabecera: pasa cuando se cambian o se quitan las fechas y esta recarga
                 no llega. Se dice AQUÍ, entre las cifras y los chips —que es a lo que afecta— y no
                 en un aviso al principio de la pantalla (§9 del CLAUDE.md del orquestador). -->
            <div class="antrunc" v-if="avisoRangoAnomalias">{{ avisoRangoAnomalias }}</div>
            <div class="chips anchips">
              <span class="chip" :class="{ on: anomChip === c.clave }" v-for="c in anomChips"
                    :key="'an-' + (c.clave || 'all')" @click="setAnomChip(c.clave)">{{ c.label }} <span class="c">{{ n(c.n) }}</span></span>
            </div>
            <!-- #326: los recuentos de los chips son del conjunto entero (los totales no llevan tope)
                 y la lista SÍ lo lleva, así que la nota dice qué parte de ese conjunto se está viendo.
                 Va junto a los chips, que es donde se crea la confusión, y no en un aviso al principio
                 de la pantalla. #543: el chip filtra ya en el servidor, así que la nota habla del
                 estado pulsado y de TODO lo que se lleva cargado, no de una sola página. -->
            <div class="antrunc" v-if="notaAnomalias">{{ notaAnomalias }}</div>
            <div class="tscroll">
              <table>
                <thead><tr>
                  <th>{{ $t('anomaliasRevisar.thPedido') }}</th><th>{{ $t('anomaliasRevisar.thCliente') }}</th>
                  <th>{{ $t('anomaliasRevisar.thPoblacion') }}</th><th>{{ $t('anomaliasRevisar.thEstado') }}</th>
                  <th>{{ $t('anomaliasRevisar.thTpc') }}</th>
                  <th style="text-align:right">{{ $t('anomaliasRevisar.thImporte') }}</th><th></th>
                </tr></thead>
                <tbody>
                  <tr v-for="l in anomLineas" :key="'anl-' + l.idPedido + '-' + l.numLinea">
                    <td class="ped">{{ l.codigoPedido || l.numeroPedido }} <span class="li">· {{ l.numLinea }}</span></td>
                    <td><div class="cli">{{ l.cliente || '—' }}</div></td>
                    <td>{{ l.poblacion || '—' }}</td>
                    <td><span class="anbadge" :class="claseAnom(l.estadoAnomalia)">{{ labelAnom(l.estadoAnomalia) }}</span></td>
                    <td><span class="antpc">{{ $t('anomaliasRevisar.tpcNo') }}</span></td>
                    <td class="price" style="text-align:right">{{ eur(l.importe) }}</td>
                    <td><a class="goped" :href="'/pedidos/view/' + l.idPedido + '/'">{{ $t('anomaliasRevisar.irPedido') }}</a></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- #543 · el camino para llegar al resto de las líneas sin salir de esta pantalla. El
                 motivo de que no se pueda pulsar va JUNTO al botón y no en un aviso de arriba: quien
                 pulsa no relaciona lo uno con lo otro (§9 del CLAUDE.md del orquestador). Sale de la
                 MISMA decisión que la nota de los chips (`estadoAnomalias`), para que las dos no
                 digan lo contrario. Con la tabla probadamente vacía no se dibuja: no hay nada que
                 cargar y el pie ya lo dice. -->
            <div class="anmas" v-if="!anomCargando && !anomaliasVacias">
              <button class="anmasbtn" :disabled="!cargarMas.puede" @click="cargarMasAnomalias()">
                {{ cargarMas.reintentar ? $t('anomaliasRevisar.reintentar') : $t('anomaliasRevisar.cargarMas') }}
                <span class="q" v-if="cargarMas.quedan">· {{ $t('anomaliasRevisar.cargarMasQuedan', { n: n(cargarMas.quedan) }) }}</span>
              </button>
              <span class="anmasmot" v-if="cargarMas.motivo">{{ cargarMas.motivo }}</span>
            </div>
          </template>
          <div class="anmas" v-else-if="anomError">
            <!-- Si lo que falló fue la PRIMERA carga no hay cifras que pintar, pero la sección tiene
                 que decirlo y dejar reintentar desde aquí, en vez de quedarse en el título. El
                 comentario va DENTRO: entre un `v-if` y su `v-else-if` no se pone nada. -->
            <button class="anmasbtn" @click="cargarAnomalias(anomError.pagina)">{{ $t('anomaliasRevisar.reintentar') }}</button>
            <span class="anmasmot">{{ $t('anomaliasRevisar.cargarMasError', { causa: anomError.causa }) }}</span>
          </div>
          <!-- #326: «Sin anomalías…» solo cuando está PROBADO que no hay nada (ver `anomaliasVacias`).
               Si no está probado, el pie cuenta lo que se enseña y la nota de arriba explica por qué
               puede no ser todo.
               Ronda 2 de revisión de la #543: una tabla vacía porque la carga de ese estado falló
               tiene que decir ESO. «0 líneas mostradas» debajo de un chip que dice 4.485 es la misma
               contradicción que enseñar las filas del chip anterior, contada por el otro lado. -->
          <div class="foot">{{ anomCargando ? $t('anomaliasRevisar.cargando')
            : anomError && !anomLineas.length ? $t('anomaliasRevisar.pieError', { causa: anomError.causa })
            : (anomaliasVacias ? $t('anomaliasRevisar.vacio')
            : $t('anomaliasRevisar.mostradas', { n: anomLineas.length })) }}</div>
        </div>
      </div>
    </div>

    <!-- popup reasignar EST PLA -->
    <f7-popup :opened="popupReasignar" @popup:closed="popupReasignar = false">
      <f7-page>
        <f7-navbar title="Reasignar EST PLA">
          <f7-nav-right><f7-link popup-close>{{ $t('common.cerrar') || 'Cerrar' }}</f7-link></f7-nav-right>
        </f7-navbar>
        <f7-block>
          <p><b>{{ seleccion.length }}</b> línea(s) seleccionada(s). El cambio pasa por el flujo canónico del
            pedido: queda en el histórico con tu usuario y ejecuta la acción automática del catálogo.</p>
          <div class="list no-hairlines">
            <select class="cpd-select" v-model="reasignarValor">
              <option :value="null">— Elige el nuevo EST PLA —</option>
              <option v-for="c in catalogo" :key="'cat-' + c.valor" :value="c.valor">{{ c.nombre_valor || (c.valor + ' - ' + c.label) }}</option>
            </select>
            <textarea class="cpd-notas" v-model="reasignarNotas" placeholder="Comentario (opcional)"></textarea>
          </div>
          <f7-button fill :class="{ disabled: !reasignarValor }" @click="confirmarReasignar()">Reasignar</f7-button>
        </f7-block>
      </f7-page>
    </f7-popup>

    <!-- #857 · histórico de cambios de motivo de una línea: cada apunte con su fecha, usuario y motivo -->
    <f7-popup :opened="!!historicoLinea" @popup:closed="historicoLinea = null">
      <f7-page>
        <f7-navbar :title="historicoLinea ? 'Histórico de motivos · ' + (historicoLinea.codigoPedido || historicoLinea.numeroPedido) + ' · ' + historicoLinea.numLinea : 'Histórico de motivos'">
          <f7-nav-right><f7-link popup-close>{{ $t('common.cerrar') || 'Cerrar' }}</f7-link></f7-nav-right>
        </f7-navbar>
        <f7-block v-if="historicoLinea">
          <table class="apd-tabla">
            <thead><tr><th>Fecha</th><th>Usuario</th><th>Motivo</th><th>Comentario</th></tr></thead>
            <tbody>
              <tr v-for="(h, i) in historicoLinea.historicoMotivos.slice().reverse()" :key="'hm-' + i">
                <td>{{ h.fecha ? fechaHora(h.fecha) : 'sin fecha registrada' }}</td>
                <td>{{ h.usuario || 'no registrado' }}</td>
                <td>{{ h.valor === 'Sin motivo' ? 'Sin motivo (vuelve a ser planificable)' : (h.label || h.valor || '—') }}</td>
                <td>{{ h.notas || '' }}</td>
              </tr>
            </tbody>
          </table>
        </f7-block>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>

<style scoped>
/* Estilo del mockup dashboard-control-planificacion.html (mismos colores/tarjetas/cabecera) */
.cpd{--violet:#7C3AED;--violet-d:#5B21B6;--violet-2:#A78BFA;--violet-soft:#F2ECFE;--ink:#191627;--muted:#6C6982;
  --faint:#9C99AE;--line:#EBE9F3;--bg:#F6F5FB;--card:#fff;--green:#0E9F6E;--amber:#B45309;--amber-s:#FBF0E1;
  --red:#DC2626;--red-s:#FDECEC;--blue:#2563EB;--blue-s:#E8F0FE;--slate:#475569;
  --sh:0 1px 3px rgba(30,20,60,.06),0 8px 24px rgba(40,20,80,.05);
  background:var(--bg);color:var(--ink);min-height:100%;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif}
.wrap{max-width:1240px;margin:0 auto;padding:0 26px 60px}
.hero{background:linear-gradient(120deg,#4C1D95 0%,#6D28D9 45%,#9D2FA6 100%);color:#fff;padding:26px 0 74px;margin-bottom:-54px}
.hero .in{max-width:1240px;margin:0 auto;padding:0 26px;display:flex;justify-content:space-between;align-items:flex-start;gap:20px;flex-wrap:wrap}
/* #544 · el rótulo «SIMECAL · ORGANISMO DE CONTROL» ya no se pinta en esta pantalla, así que su
   regla se va con él. El título arranca ahora en la primera línea de la cabecera: sin el margen
   superior el degradado le quedaba pegado. */
.htitle{font-size:26px;font-weight:800;letter-spacing:-.4px;margin:0 0 3px}
.hsub{opacity:.8;font-size:13.5px}
/* Ronda 1 de revisión de la #544 · el fallo de las cifras, en la misma línea que su estado normal:
   se lee sin buscarlo y no mueve nada de sitio. */
.hsub .hserr{opacity:1;font-weight:800;color:#FFE1E1}
/* La columna es nueva (la nota del filtro de fechas necesita su línea); la FILA conserva
   exactamente las reglas que tenía `.hfilters`, así que los cuatro filtros de siempre no se mueven. */
.hfilters{display:flex;flex-direction:column;align-items:flex-end;gap:6px}
.hfrow{display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end}
.sel{background:rgba(255,255,255,.15);border:1px solid rgba(255,255,255,.25);color:#fff;font-size:12.5px;font-weight:600;
  padding:8px 12px;border-radius:10px;appearance:auto;cursor:pointer}
.sel option{color:#191627}
.sel-hi{background:rgba(255,255,255,.28);border-color:rgba(255,255,255,.45)}
/* #544 · «Desde»/«Hasta», con el mismo aire que los selects de al lado. */
.fch{display:inline-flex;align-items:center;gap:6px;background:rgba(255,255,255,.15);
  border:1px solid rgba(255,255,255,.25);color:#fff;font-size:12.5px;font-weight:600;
  padding:5px 10px;border-radius:10px}
.fch input{background:rgba(255,255,255,.92);border:none;border-radius:7px;color:#191627;
  font-size:12.5px;font-weight:700;padding:3px 6px;font-family:inherit}
.fch.mal{border-color:#FCA5A5;background:rgba(220,38,38,.28)}
.hfnota{font-size:11.5px;font-weight:600;opacity:.85;text-align:right;max-width:560px}
.hfnota.mal{opacity:1;font-weight:800;color:#FFE1E1}
.fchclr{margin-left:8px;color:#fff;font-weight:800;text-decoration:underline;cursor:pointer;white-space:nowrap}
.kpis{display:grid;grid-template-columns:repeat(6,1fr);gap:12px;margin-bottom:22px}
@media (max-width:1100px){.kpis{grid-template-columns:repeat(3,1fr)}}
.kpi{background:var(--card);border:1px solid var(--line);border-radius:16px;padding:16px 17px;box-shadow:var(--sh)}
.kpi .k{font-size:11px;color:var(--muted);font-weight:700;text-transform:uppercase;letter-spacing:.5px;display:flex;align-items:center;gap:6px}
.kpi .v{font-size:24px;font-weight:800;margin-top:7px;letter-spacing:-.5px}
.kpi .v small{font-size:13px;color:var(--muted);font-weight:700}
.kpi .d{font-size:11.5px;margin-top:4px;font-weight:700}
.dmut{color:var(--muted)}
.up{color:var(--green)}.warn{color:var(--amber)}.dot{width:9px;height:9px;border-radius:50%;display:inline-block}
.cols{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:16px}
@media (max-width:1000px){.cols{grid-template-columns:1fr}}
.panel{background:var(--card);border:1px solid var(--line);border-radius:16px;padding:18px 20px;box-shadow:var(--sh)}
.ph{display:flex;justify-content:space-between;align-items:center;margin-bottom:16px}
.ph .t{font-size:15px;font-weight:800}
.ph .s{font-size:11.5px;color:var(--faint);font-weight:600}
.donutwrap{display:flex;align-items:center;gap:22px}
.donut{position:relative;width:150px;height:150px;flex:none}
.donut .ctr{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center}
.donut .ctr .big{font-size:30px;font-weight:800;letter-spacing:-1px}
.donut .ctr .lbl{font-size:11px;color:var(--muted);font-weight:700}
.leg{display:flex;flex-direction:column;gap:9px;flex:1}
.leg .r{display:flex;align-items:center;gap:9px;font-size:12.5px}
.leg .r .nm{flex:1;font-weight:600}
.leg .r .vv{font-weight:800}
.leg .r .pc{color:var(--muted);font-size:11px;width:34px;text-align:right}
.bars{display:flex;flex-direction:column;gap:12px}
.brow .bl{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:5px}
.brow .nm{font-size:12.5px;font-weight:700}
.brow .nm .cc{color:var(--faint);font-size:11px;font-weight:700;margin-right:6px}
.brow .am{font-size:12px;color:var(--muted);font-weight:700}.brow .am b{color:var(--ink)}
.track{height:13px;background:var(--bg);border-radius:999px;overflow:hidden}
.fill{height:100%;border-radius:999px;background:linear-gradient(90deg,var(--violet),var(--violet-2))}
.fill.teal{background:linear-gradient(90deg,#0E9F6E,#4ADE80)}
.team{display:grid;grid-template-columns:repeat(4,1fr);gap:10px}
.tc{background:var(--bg);border:1px solid var(--line);border-radius:12px;padding:11px 12px;text-align:center}
.tc .av{width:34px;height:34px;border-radius:50%;margin:0 auto 6px;background:var(--violet);color:#fff;font-weight:800;font-size:12px;display:flex;align-items:center;justify-content:center}
.tc .nm{font-size:12px;font-weight:800}.tc .n{font-size:11px;color:var(--muted);font-weight:700;margin-top:2px}
.act{background:var(--amber-s);border:1px solid #F0D8B4;border-radius:14px;padding:13px 16px;display:flex;gap:12px;align-items:center;margin-bottom:16px}
.act .i{font-size:20px}.act .t{font-size:13.5px;font-weight:800;color:#7c4a08}.act .m{font-size:12px;color:#8a6535}
.act button{margin-left:auto;border:none;background:var(--amber);color:#fff;font-weight:800;font-size:12.5px;padding:9px 14px;border-radius:10px;cursor:pointer}
.tsec{background:var(--card);border:1px solid var(--line);border-radius:16px;box-shadow:var(--sh);overflow:hidden}
.tstop{padding:16px 20px;border-bottom:1px solid var(--line);display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:12px}
.tstop .t{font-size:15px;font-weight:800}
.tstop .t small{color:var(--muted);font-weight:700;font-size:12px;margin-left:6px}
/* #326 · la nota del recorte, debajo de las cifras a las que se refiere (no es un aviso de pantalla) */
.tstop .t .trunc{color:var(--amber);font-weight:700;font-size:11.5px;margin-top:3px}
.antrunc{color:var(--amber);font-weight:700;font-size:11.5px;padding:0 20px 12px}
.chips{display:flex;gap:7px;flex-wrap:wrap}
.chip{border:1px solid var(--line);background:#fff;color:var(--muted);font-size:12px;font-weight:700;padding:6px 12px;border-radius:999px;cursor:pointer;transition:.12s}
.chip:hover{border-color:var(--violet-2)}
.chip.on{background:var(--violet);border-color:var(--violet);color:#fff}
.chip .c{opacity:.75;font-weight:800;margin-left:5px}
.bulk{display:none;padding:11px 20px;background:var(--violet-soft);border-bottom:1px solid #E4DAFB;align-items:center;gap:12px;flex-wrap:wrap}
.bulk.on{display:flex}
/* #543 · sin selección la barra sigue ahí (Exportar la necesita) pero no grita: fondo neutro y los
   dos botones que piden filas marcadas, apagados y con el motivo al lado. */
.bulk.vacia{background:#FBFAFE;border-bottom-color:var(--line)}
.bulk.vacia .n{color:var(--muted)}
.bulk .n{font-weight:800;font-size:13px;color:var(--violet-d)}
.bulk .mot{font-size:11.5px;color:var(--muted);font-weight:700}
.bulk .sp{flex:1}
.bulk button{border:1px solid var(--violet-2);background:#fff;color:var(--violet-d);font-weight:700;font-size:12.5px;padding:7px 13px;border-radius:9px;cursor:pointer}
.bulk button.primary{background:var(--violet);color:#fff;border-color:var(--violet)}
.bulk button:disabled{opacity:.5;cursor:default;border-color:var(--line);color:var(--muted)}
.bulk button.primary:disabled{background:#CFC6E6;border-color:#CFC6E6;color:#fff}
/* min-height: al recargar con menos filas la sección no colapsa (evita el layout-shift del filtrado) */
.tscroll{overflow-x:auto;min-height:260px}
table{width:100%;border-collapse:collapse;font-size:12.5px}
thead th{text-align:left;padding:11px 14px;font-size:11px;color:var(--muted);font-weight:800;text-transform:uppercase;letter-spacing:.4px;background:#FBFAFE;border-bottom:1px solid var(--line);position:sticky;top:0}
tbody td{padding:12px 14px;border-bottom:1px solid var(--line);vertical-align:top}
tbody tr:hover{background:#FBFAFE}
tbody tr.sel{background:var(--violet-soft)}
.ped{font-weight:800}.ped .li{color:var(--faint);font-weight:700}
.cli{font-weight:600}.sub{color:var(--muted);font-size:11.5px;margin-top:2px}
.mat{display:inline-block;background:var(--bg);border:1px solid var(--line);border-radius:6px;padding:2px 7px;font-size:11px;font-weight:800;color:var(--slate)}
.price{font-weight:800;white-space:nowrap}
/* #857 · la pastilla puede partirse en dos renglones: sin esto, las etiquetas largas («NO PLANF. ESPERAR
   CORRECCIÓN DEFECTOS») fijaban por sí solas más de 300 px de columna y la tabla no cabía a 1366. */
.epla{display:inline-flex;align-items:center;gap:5px;font-size:11px;font-weight:800;padding:3px 9px;border-radius:999px}
.e-call{background:var(--blue-s);color:var(--blue)}.e-cont{background:var(--red-s);color:var(--red)}
.e-doc{background:var(--amber-s);color:var(--amber)}.e-ava{background:#F1E9FB;color:var(--violet-d)}.e-oth{background:#EEE;color:#555}
.com{color:var(--muted);font-size:11.5px}
/* #857 · fila de acciones de cada línea (comentario e «Ir al pedido»): se lee como parte de la línea
   de arriba, así que esa pierde su raya y las dos se iluminan juntas. */
tbody tr.lin td{border-bottom:none;padding-bottom:6px}
tbody tr.acc td{padding-top:0;padding-bottom:10px}
tbody tr.lin:hover + tr.acc:not(.sel),tbody tr.lin:not(.sel):has(+ tr.acc:hover){background:#FBFAFE}
.acc-in{display:flex;justify-content:space-between;align-items:baseline;gap:16px}
.goped{color:var(--violet);font-weight:800;text-decoration:none;white-space:nowrap;font-size:12px}
.apd{font-size:12px}
/* Un usuario largo sin espacios (o un correo) no puede ensanchar la columna hasta sacarla de la tabla. */
.apd-por{overflow-wrap:anywhere}
.apd-sin{color:var(--muted);font-style:italic}
.apd-hist{color:var(--violet);font-size:11.5px;cursor:pointer;white-space:nowrap}
.apd-tabla{width:100%;border-collapse:collapse;font-size:13px}
.apd-tabla th,.apd-tabla td{text-align:left;padding:6px 8px;border-bottom:1px solid #eee;vertical-align:top}
.goped:hover{text-decoration:underline}
.chk{width:16px;height:16px;accent-color:var(--violet);cursor:pointer}
.foot{text-align:center;color:var(--faint);font-size:11.5px;padding:16px}
.vacio{color:var(--faint);font-size:12px;padding:8px 0}
.cpd-select{width:100%;padding:10px;border:1px solid #ddd;border-radius:8px;margin-bottom:10px}
.cpd-notas{width:100%;min-height:70px;padding:10px;border:1px solid #ddd;border-radius:8px;margin-bottom:14px}
/* PALANCA C FASE 2: sección "Anomalías a revisar" (paleta de la maqueta anomalias-a-revisar.html) */
.anomsec{margin-top:18px}
.anhead{display:flex;align-items:center;gap:10px;padding:15px 20px;border-bottom:1px solid var(--line);background:linear-gradient(160deg,#fff,#faf9ff)}
.anhead .t{font-size:15px;font-weight:800}
.anbar{width:4px;height:24px;border-radius:3px;background:#d03b3b}
.anhint{margin-left:auto;font-size:11.5px;color:var(--faint)}
.anlead{font-size:12.5px;color:#54545f;margin:14px 20px;padding:10px 14px;background:#efedfb;border:1px solid #ddd7f6;border-radius:10px}
.antiles{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin:0 20px 14px}
.antile{border-radius:12px;padding:13px 16px;border:1px solid;position:relative;overflow:hidden}
.antile .ico{position:absolute;right:12px;top:10px;font-size:17px;opacity:.5}
.antile .lab{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.03em}
.antile .val{font-size:26px;font-weight:800;letter-spacing:-.02em;margin-top:4px}
.antile .sub{font-size:11.5px;font-weight:600;margin-top:2px}
.antile .eurv{font-size:13.5px;font-weight:750;margin-top:6px}
.an-crit{background:linear-gradient(160deg,#fff,#fdecec);border-color:#f6d2d2;color:#b3312f}
.an-crit .val,.an-crit .eurv{color:#a5231f}
.an-warn{background:linear-gradient(160deg,#fff,#fff6e8);border-color:#f5e2bf;color:#a5670a}
.an-warn .val,.an-warn .eurv{color:#8a5600}
.an-slate{background:linear-gradient(160deg,#fff,#eef1f6);border-color:#e0e5ee;color:#4a5568}
.an-slate .val,.an-slate .eurv{color:#37414f}
.anchips{padding:0 20px 12px}
/* #543 · «Cargar más» y, pegado a él, el motivo de que no se pueda pulsar. */
.anmas{display:flex;align-items:center;gap:10px;padding:12px 20px;border-top:1px solid var(--line);flex-wrap:wrap}
.anmasbtn{border:1px solid var(--violet-2);background:#fff;color:var(--violet-d);font-weight:800;font-size:12.5px;padding:8px 15px;border-radius:9px;cursor:pointer}
.anmasbtn:hover:enabled{background:var(--violet-soft)}
.anmasbtn:disabled{opacity:.5;cursor:default;border-color:var(--line);color:var(--muted)}
.anmasbtn .q{font-weight:700;opacity:.8}
.anmasmot{font-size:11.5px;color:var(--muted);font-weight:700}
.anbadge{font-size:11px;font-weight:700;padding:2px 9px;border-radius:999px;white-space:nowrap;border:1px solid}
.b-cob{background:#fdecec;color:#b3312f;border-color:#f6d2d2}
.b-fac{background:#fff1f1;color:#c1443f;border-color:#f7dada}
.b-eje{background:#fff6e8;color:#a5670a;border-color:#f5e2bf}
.b-sap{background:#eef1f6;color:#4a5568;border-color:#e0e5ee}
.antpc{font-size:11px;font-weight:700;color:#b3312f;background:#fdecec;border:1px solid #f6d2d2;padding:1px 7px;border-radius:6px}
@media(max-width:820px){.antiles{grid-template-columns:1fr}}

/* #16 · sello de "de cuando son estos datos", mismo sitio en todas las pantallas. */
.sello-datos-bar { padding: 6px 16px 0; }
</style>

<script>
import ControlPlanificacion from '../../js/db/ControlPlanificacion.js';
import ResumenRecorte from '../../js/ResumenRecorte.js';

import SelloDatos from '../../components/SelloDatos.vue';
import preloaderDeLaSesion from '../../js/utils/preloaderDeLaSesion.js';
import cerrojoDeLaSesion from '../../js/utils/cerrojoDeLaSesion.js';
const COLORES_DONUT = ['#0E9F6E', '#7C3AED', '#B45309', '#CBD5E1'];
const CLASES_EPLA = { ESTPLAN002: 'e-ava', ESTPLAN003: 'e-call', ESTPLAN004: 'e-doc', ESTPLAN005: 'e-doc', ESTPLAN006: 'e-cont' };
// PALANCA C FASE 2: badge por estado DOMINANTE de la anomalía (paleta de la maqueta anomalias-a-revisar)
const CLASES_ANOM = { COBRADA: 'b-cob', FACTURADA: 'b-fac', EJECUTADA: 'b-eje', CERRADA_SAP: 'b-sap' };
// #543 · tamaño de página de «Anomalías a revisar». Es el mismo que pedía la pantalla antes de
// paginar, a propósito: la carga inicial tiene que seguir costando lo mismo que hoy, y lo que cambia
// es que ahora hay páginas siguientes y solo se piden cuando alguien las pide.
const ANOM_POR_PAGINA = 300;
// #543 · el Exportar del filtro entero recorre /lineas por páginas del tamaño máximo que admite
// (500). El tope de páginas es una red de seguridad: si se alcanza, el CSV sale incompleto y se
// dice; lo que no puede pasar es que el navegador se quede dando vueltas en silencio.
const EXPORT_POR_PAGINA = 500;
const EXPORT_MAX_PAGINAS = 80;

export default {
  components: { SelloDatos },
  data() {
    return {
      ControlPlanificacion,
      hoy: new Date().toLocaleDateString('es-ES'),
      // #544 · `desdeStr`/`hastaStr` son lo que se escribe en los dos `input type=date`: 'AAAA-MM-DD'
      // o vacío. Lo que viaja a la API son instantes, y la conversión está en un solo sitio
      // (`instanteDia`), porque la ventana es semiabierta y el «Hasta» que se elige SÍ se ve.
      filtro: { planificadora: null, provincia: null, materia: null, planificable: null,
                desdeStr: null, hastaStr: null },
      opciones: { planificadoras: [], provincias: [], materias: [] },
      agg: { totales: {}, porEstado: [], porEstPla: [], porPlanificadora: [], porProvincia: [] },
      kpi: { lineas: 0, importe: 0, planificables: 0, planificadas: 0, pendientes: 0, noPlanificables: 0, importeNoPlan: 0 },
      // #860 · `{total, apartada, sinApartada}` de /agregados, cada una con lineas, importe, horas y
      // lineasSinTiempo. null mientras no llega (o si la API aún no la manda): el recuadro se queda
      // como estaba en vez de pintar ceros que no son.
      cartera: null,
      fichas: { inspectores: 0, conFicha: 0, sinFicha: 0 },
      catalogo: [],
      lineas: [],
      // #326 · lo que la API dice del conjunto del que sale `lineas`: cuántas hay en total y si lo
      // que viaja es todo o una parte. Viene en la MISMA respuesta y de la misma consulta.
      lineasResumen: null,
      // Ronda 1 de revisión de la #543 · lo que le pasó a la ÚLTIMA carga de la tabla, cuando no
      // salió bien. No se tiran las filas que ya se veían (lo que se ve sigue siendo cierto), pero
      // el pie dice que son las de la consulta anterior: callar dejaba la tabla enseñando el filtro
      // de antes como si fuera el que se acaba de pedir (§9 del CLAUDE.md del orquestador).
      lineasError: null,
      // Ronda 1 de revisión de la #544 · lo que le pasó a la última carga de los agregados (los seis
      // recuadros, el círculo, las barras y el recuento de fichas). Mismo papel que `lineasError` en
      // la tabla: las cifras de antes se quedan —son ciertas, de su filtro— y la cabecera dice de qué
      // consulta son.
      aggError: null,
      // Si alguna carga de agregados llegó a traer cifras. Sin esto, un fallo en la PRIMERA carga
      // diría «se siguen viendo las del filtro anterior» sobre seis recuadros a cero, que no son de
      // ningún filtro anterior: no hay ninguno.
      aggCargado: false,
      chipActivo: null,
      seleccion: [],
      cargando: false,
      cargandoAgg: false,
      popupReasignar: false,
      historicoLinea: null,
      reasignarValor: null,
      reasignarNotas: '',
      // PALANCA C FASE 2: anomalías a revisar (ámbito GLOBAL como la maqueta: control de deuda y
      // saneamiento — no depende de los filtros de cabecera del dashboard)
      anom: null,
      // Ronda 1 de revisión de la #544 · la ventana de fechas con la que se pidió lo que hay en
      // `anom`. Las tarjetas y los recuentos de los chips no dependen del chip —por eso un fallo no
      // los tira (ver `cargarAnomalias`)—, pero desde la #544 SÍ dependen del rango, así que ya no
      // se pueden rotular con el rango que haya escrito en la cabecera: hay que rotularlos con el
      // suyo. `null` mientras no hay cifras.
      anomVentana: null,
      anomChip: null,
      anomCargando: false,
      // #543 · la lista deja de ser `anom.lineas` y pasa a ser lo ACUMULADO de las páginas pedidas:
      // «Cargar más» añade, no sustituye. `anomResumen` es lo que la API dice de ese acumulado.
      anomLineas: [],
      anomResumen: null,
      anomPagina: 0,
      anomCargandoMas: false,
      // Ronda 1 de revisión de la #543 · el fallo de la última carga, CON la página que se estaba
      // pidiendo: `{ pagina, causa }`. Vale para las dos —la del chip (página 0) y la de «Cargar
      // más»—, porque lo que hay que hacer es lo mismo en las dos: decir qué pasó junto al control y
      // dejar reintentar ESA página. Un solo sitio, para que el control no acabe diciendo dos cosas.
      anomError: null,
      // Una página vacía PRUEBA que detrás no hay nada más, aunque no se sepa el total: sin esto,
      // «Cargar más» seguía vivo pidiendo páginas vacías una tras otra.
      anomFin: false,
      // Ronda 1 de revisión de la #543 · el testigo de «para qué filtro era esta respuesta». Las
      // respuestas no vuelven en orden: si se pulsa otro chip (u otro filtro) mientras hay una
      // petición en vuelo, la que llega tarde pisaba el estado de la que sí se está mirando, y en el
      // caso de «Cargar más» concatenaba líneas de un estado bajo el chip de otro. Cada carga se
      // queda con su número y solo aplica lo que trae si sigue siendo la última pedida.
      peticiones: { anomalias: 0, lineas: 0, agregados: 0 },
      // #543 · el Exportar del filtro entero tarda varias peticiones: el botón lo dice y se apaga,
      // pero la pantalla no se bloquea (nada de preloader modal).
      exportando: false,
      exportProgreso: 0
    };
  },
  computed: {
    // ---- #544 · el filtro de fechas de la cabecera ----
    //
    // Hay rango cuando se ha escrito al menos una de las dos: la ventana es abierta por el lado que
    // se deja vacío.
    rangoActivo() {
      return !!(this.filtro.desdeStr || this.filtro.hastaStr);
    },
    // Las dos cadenas son 'AAAA-MM-DD', así que compararlas como texto es comparar las fechas. No se
    // construyen Date para esto: un 'AAAA-MM-DD' a medio escribir daría `Invalid Date` y el aviso
    // aparecería y desaparecería mientras se teclea.
    rangoInvalido() {
      return !!(this.filtro.desdeStr && this.filtro.hastaStr
        && this.filtro.desdeStr > this.filtro.hastaStr);
    },
    // Si el rango se está aplicando DE VERDAD a lo que se está viendo. Es esto —y no «hay algo
    // escrito en las dos casillas»— lo que miran todas las frases de la pantalla que hablan del
    // rango, para que ninguna afirme un filtro que no está puesto.
    rangoAplicado() {
      return this.rangoActivo && !this.rangoInvalido;
    },
    // Lo que se lee JUNTO al control, en las tres situaciones y en una sola frase:
    //   · qué fecha se está filtrando — sin esto nadie puede saber por qué fecha filtra, y era un
    //     requisito expreso de Dirección;
    //   · qué se queda fuera cuando hay rango: la fecha es la del PEDIDO y vale la más reciente de
    //     sus líneas ejecutadas, así que un pedido sin ejecutar del todo no cae en ningún rango. En
    //     una pantalla que mira sobre todo líneas pendientes, eso es justo lo que sorprende;
    //   · y, con el rango al revés, que NO se está aplicando, con la salida a mano. Se dice así —y no
    //     «las cifras son las del rango anterior»— porque con el rango al revés la pantalla se recarga
    //     sin ventana: si se quedara con lo de antes, tocar cualquier otro filtro traería cifras sin
    //     rango bajo un aviso diciendo que son del rango de antes, y serían dos cosas distintas en la
    //     misma pantalla (§9 del CLAUDE.md del orquestador).
    notaFechas() {
      // #619 · sin rango que viaje —vacías o al revés— «Anomalías a revisar» cuenta su ventana por
      // defecto, y la nota tiene que exceptuarla en los DOS casos: con el rango al revés, decir que la
      // pantalla no está filtrada por fechas mientras el panel dice «últimos 5 años» eran dos partes de
      // la misma pantalla diciendo lo contrario (revisión de Codex, ronda 1). Es la ventana de las
      // cifras que hay en pantalla, la que ha devuelto el servidor, no una que se suponga aquí.
      const v = this.ventanaAnom;
      const salvoAnomalias = v && v.porDefecto && v.anios
        ? ', salvo en «Anomalías a revisar», que cuenta los últimos ' + v.anios + ' años' : '';
      if (this.rangoInvalido) {
        return 'El «Desde» es posterior al «Hasta», así que las cifras de esta pantalla NO están '
          + 'filtradas por fechas' + salvoAnomalias + '. Corrige una de las dos y el rango se aplica.';
      }
      const porQueFecha = 'Las fechas filtran por la fecha de ejecución del pedido (ambas incluidas).';
      if (!this.rangoActivo) {
        // #619 · «todas las fechas» ya no vale para toda la pantalla. Se dice aquí, junto al control
        // con el que se amplía, para que quien vaya a buscar lo anterior sepa que este es el camino.
        return porQueFecha + ' Vacías, se ven todas las fechas' + salvoAnomalias + '.';
      }
      return porQueFecha + ' Los pedidos que todavía no tienen fecha de ejecución quedan fuera del rango.';
    },
    // El rótulo del ámbito de «Anomalías a revisar». Dice la verdad en los dos casos: la sección sigue
    // siendo global —no la tocan Planificadora, Provincia, Materia ni Planificable— pero el rango de
    // fechas SÍ la acota desde la #544, y callarlo dejaría unas tarjetas contando otro conjunto que
    // las cifras de arriba sin que nada lo dijera (§9 del CLAUDE.md del orquestador).
    //
    // Ronda 1 de revisión de la #544 · y habla del rango con el que se pidieron las cifras QUE ESTÁN
    // EN PANTALLA, no del que haya escrito en la cabecera: entre lo uno y lo otro cabe una carga en
    // vuelo o una que falló, y entonces anunciar el rango nuevo sobre las tarjetas del anterior es
    // exactamente el defecto que esto evita. Mientras no hay cifras, el rango que se va a pedir.
    //
    // #619 · sin rango en la cabecera, lo que hay en pantalla es la ventana por defecto que ha aplicado
    // el servidor, y el rótulo dice sus años. Mientras no hay cifras no se sabe cuántos son, así que se
    // queda en el rótulo de siempre: el panel aún no enseña ninguna cifra a la que contradecir.
    hintAnomalias() {
      const v = this.ventanaAnom;
      if (this.anom && !this.anomConRango && v && v.porDefecto && v.anios) {
        return this.$t('anomaliasRevisar.hintVentanaDefecto', { n: v.anios });
      }
      const conRango = this.anom ? this.anomConRango : this.rangoAplicado;
      return this.$t(conRango ? 'anomaliasRevisar.hintConFechas' : 'anomaliasRevisar.hint');
    },
    /**
     * #619 · La ventana que el servidor ha APLICADO a las cifras que hay en pantalla (`{desde, hasta,
     * porDefecto, anios}`), o `null` con una API anterior que no la publica. Es la de la respuesta y no
     * la de la cabecera: con la por defecto, la pantalla no puede saber la fecha por su cuenta.
     */
    ventanaAnom() {
      return (this.anom && this.anom.ventana) || null;
    },
    // #619 · la línea de la ventana, junto a las tres tarjetas. Dice la ventana que se está contando,
    // cuántas líneas e importe se quedan fuera —también cuando son cero: callarlo se leería como que
    // no se sabe— y, con la por defecto, por dónde se llega a ellas y que la parte de arriba no lleva
    // esta ventana. Sin ventana (o con una API anterior) no dice nada: el rótulo del ámbito ya dice
    // «global».
    notaVentanaAnomalias() {
      const v = this.ventanaAnom;
      if (!v || (!v.desde && !v.hasta)) return null;
      const self = this;
      const partes = [];
      if (v.porDefecto) {
        partes.push(self.$t('anomaliasRevisar.ventanaDefecto', { n: v.anios, desde: self.dia(v.desde) }));
      } else {
        partes.push(self.$t('anomaliasRevisar.ventanaRango', { rango: self.textoRango(v) }));
      }
      const f = self.anom.fueraDeVentana;
      if (f && typeof f.n === 'number') {
        if (f.n > 0) {
          partes.push(self.$t('anomaliasRevisar.ventanaFuera', {
            n: self.n(f.n),
            importe: self.eur(f.importe),
            sinFecha: f.sinFecha > 0
              ? self.$t('anomaliasRevisar.ventanaFueraSinFecha', { n: self.n(f.sinFecha) }) : ''
          }));
          if (v.porDefecto && f.n > (f.sinFecha || 0)) partes.push(self.$t('anomaliasRevisar.ventanaAmpliar'));
        } else {
          partes.push(self.$t('anomaliasRevisar.ventanaFueraNinguna'));
        }
      }
      if (v.porDefecto) partes.push(self.$t('anomaliasRevisar.ventanaArriba'));
      return partes.join(' ');
    },
    // Ronda 1 de revisión de la #544 · lo que la cabecera dice de los seis recuadros, el círculo y las
    // barras cuando su última carga no llegó. Dos frases, porque los dos casos no dicen lo mismo: con
    // cifras en pantalla hay que avisar de QUÉ son (del filtro anterior, no del que está puesto), y
    // sin ellas los recuadros están a cero y lo que hay que decir es que no se han podido cargar —un
    // cero que se lee como «no hay nada» es el mismo defecto por el otro lado.
    avisoCifras() {
      if (!this.aggError) return null;
      return this.aggCargado
        ? 'no se han podido actualizar las cifras: ' + this.aggError
          + ' · se siguen viendo las del filtro anterior'
        : 'no se han podido cargar las cifras: ' + this.aggError;
    },
    /** ¿Llevaban rango de fechas las cifras que hay en pantalla? */
    anomConRango() {
      const v = this.anomVentana;
      return !!(v && (v.desde || v.hasta));
    },
    // Ronda 1 de revisión de la #544 · qué se lee junto a las tarjetas cuando las cifras que hay en
    // pantalla NO son del rango que está puesto. Solo pasa si la recarga de esta sección falló: las
    // tres tarjetas y los recuentos de los chips siguen siendo ciertos —de su rango— y tirarlos se
    // llevaría por delante los chips y la forma de reintentar, que es la decisión de la ronda 1 de la
    // #543 y el motivo de que un fallo no vacíe `anom`. Así que se quedan, pero DICIENDO de qué rango
    // son y dónde se vuelve a intentar: el pie y el botón solo hablan del fallo de las líneas.
    //
    // Mientras la carga está en vuelo no se dice nada: el pie ya pone «Cargando…» y el rótulo del
    // ámbito sigue siendo el de las cifras que se ven, así que nada se contradice.
    avisoRangoAnomalias() {
      if (!this.anom || this.anomCargando) return null;
      if (this.claveVentana(this.anomVentana) === this.claveVentana(this.ventanaFechas())) return null;
      if (this.anomConRango) return this.$t('anomaliasRevisar.rangoAnterior');
      // #619 · sin rango pedido, las cifras de antes ya no son «de todas las fechas» sino de la
      // ventana por defecto, si el servidor la aplicó: decir lo otro sería afirmar un conjunto que no
      // es el que se ve.
      const v = this.ventanaAnom;
      return v && v.porDefecto && v.anios
        ? this.$t('anomaliasRevisar.rangoVentanaDefecto', { n: v.anios })
        : this.$t('anomaliasRevisar.rangoSinFechas');
    },
    donutSegs() {
      // Partición coherente con los facets del backend: planificadas + en proceso + no planificables +
      // pendientes = total (los no-planificables se sacan de su estado, como en el mockup).
      const total = this.kpi.lineas || 1;
      const grupos = [
        { nombre: 'Planificadas / ejecutadas', n: this.kpi.planificadas },
        { nombre: 'En proceso / entrega / factura', n: Math.max(0, this.kpi.lineas - this.kpi.planificadas - this.kpi.pendientes - this.kpi.noPlanificables) },
        { nombre: 'No planificables (EST PLA)', n: this.kpi.noPlanificables },
        { nombre: 'Pendientes de planificar', n: this.kpi.pendientes }
      ];
      let offset = 25;
      return grupos.map(function(g, i) {
        const dash = Math.max(0, (g.n / total) * 100);
        const seg = { nombre: g.nombre, n: g.n, color: COLORES_DONUT[i], dash: dash.toFixed(1), offset: offset };
        offset -= dash;
        return seg;
      });
    },
    barrasEstPla() {
      const arr = (this.agg.porEstPla || [])
        .filter(function(e) { return e._id && e._id.valor && e._id.valor !== 'ESTPLAN001'; });
      const max = Math.max.apply(null, [1].concat(arr.map(function(e) { return e.n; })));
      return arr.map(function(e) {
        return {
          valor: e._id.valor,
          cc: String(e._id.valor).replace('ESTPLAN', ''),
          label: e._id.label || e._id.valor,
          n: e.n,
          importe: e.importe,
          pctBarra: Math.round((e.n / max) * 100)
        };
      });
    },
    equipoTop() {
      const arr = this.agg.porPlanificadora || [];
      const top = arr.slice(0, 3).map(function(e) {
        return { nombre: e._id, avatar: String(e._id).substring(0, 4), n: e.n, gris: false };
      });
      if (arr.length > 3) {
        const resto = arr.slice(3);
        top.push({
          nombre: resto.map(function(e) { return e._id; }).slice(0, 2).join(' · ') + (resto.length > 2 ? '…' : ''),
          avatar: '+' + resto.length,
          n: resto.reduce(function(s, e) { return s + e.n; }, 0),
          gris: true
        });
      }
      return top;
    },
    provinciasTop() {
      const arr = (this.agg.porProvincia || []).filter(function(e) { return e._id; });
      const max = Math.max.apply(null, [1].concat(arr.map(function(e) { return e.n; })));
      const top = arr.slice(0, 4).map(function(e) {
        return { nombre: e._id, n: e.n, pctBarra: Math.round((e.n / max) * 100) };
      });
      if (arr.length > 4) {
        const resto = arr.slice(4);
        const nResto = resto.reduce(function(s, e) { return s + e.n; }, 0);
        top.push({
          nombre: resto.slice(0, 3).map(function(e) { return e._id; }).join(' · ') + (resto.length > 3 ? '…' : ''),
          n: nResto,
          pctBarra: Math.round((nResto / max) * 100)
        });
      }
      return top;
    },
    chipsEstPla() {
      return this.barrasEstPla.map(function(b) {
        return { valor: b.valor, labelCorto: b.label.length > 22 ? b.label.substring(0, 22) + '…' : b.label, n: b.n };
      });
    },
    totalChips() {
      return this.barrasEstPla.reduce(function(s, b) { return s + b.n; }, 0);
    },
    tituloTabla() {
      return this.filtro.planificable === null ? 'No planificables por resolver' : 'Líneas del filtro';
    },
    sumaTabla() {
      return this.lineas.reduce(function(s, l) { return s + (l.importe || 0); }, 0);
    },
    // ---- #326: lo que esta tabla puede AFIRMAR de las cifras que rotula ----
    //
    // La lista es una PÁGINA (el front pide 300, el servidor topa en 500), así que su longitud es «lo
    // que se enseña» y nunca el total del filtro. Lo que hay detrás lo dice el `resumen` que viene en
    // la misma respuesta, con la conclusión ya hecha: aquí NO se compara nada (ver `ResumenRecorte`).
    resumenTabla() {
      return ResumenRecorte.estado(this.lineasResumen, this.lineas.length, this.sumaTabla);
    },
    cifrasTabla() {
      const self = this;
      const cifras = ResumenRecorte.cifras(self.resumenTabla,
        { num: function(v) { return self.n(v); }, eur: function(v) { return self.eur(v); } }, 'líneas');
      // Ronda 2 de revisión de la #543 · el mismo olvido que señalaron en las anomalías, en la otra
      // tabla: con la última carga fallida, `chipActivo` y los filtros son ya los nuevos y estas
      // cifras son del conjunto ANTERIOR. El pie dice que las filas son de la consulta de antes, y la
      // cabecera tiene que decir lo mismo: rotular «610 líneas» encima del chip que se acaba de
      // pulsar es dar por hecho un total que no se ha medido (§9 del CLAUDE.md del orquestador).
      // Sin filas no hay consulta anterior de la que hablar —el fallo fue la primera carga—: la
      // cabecera calla y el pie cuenta lo que pasó, en vez de rotular un «0 líneas · 0 €» que
      // afirmaría que el filtro está vacío.
      if (self.lineasError) {
        return self.lineas.length ? cifras + ' · de la consulta anterior' : '';
      }
      return cifras;
    },
    notaTabla() {
      return ResumenRecorte.nota(this.resumenTabla);
    },
    // #326 · «no hay líneas» lo decide el mismo sitio que la nota, no un `lineas.length` del pie: es
    // la misma afirmación. Aquí los chips de EST PLA filtran EN EL SERVIDOR (`setChip` recarga), así
    // que lo que se pinta es la página y el cero sí demuestra el vacío: el pie dice lo mismo que
    // antes. Pasa por el módulo para que la regla viva en un sitio y no se tuerza si algún día este
    // filtro se hace en el cliente, que es como se abrió el agujero en la tabla de anomalías.
    // Ronda 2 de revisión de la #543 · con la última carga fallida no se afirma el vacío, igual que
    // en `anomaliasVacias` y por lo mismo: sin filas y sin resumen —una primera carga que no
    // llegó— el módulo concluiría «no hay nada», y lo que hay es que no se sabe. Un fallo no es una
    // prueba.
    tablaVacia() {
      return !this.lineasError && ResumenRecorte.estaVacia(this.resumenTabla);
    },
    todoSeleccionado() {
      return this.lineas.length > 0 && this.seleccion.length === this.lineas.length;
    },
    // ---- PALANCA C FASE 2: anomalías a revisar ----
    anomChips() {
      const pe = (this.anom && this.anom.porEstado) || {};
      return [
        { clave: null, label: this.$t('anomaliasRevisar.chipTodas'), n: (this.anom && this.anom.total && this.anom.total.n) || 0 },
        { clave: 'COBRADA', label: this.$t('anomaliasRevisar.chipCobradas'), n: pe.COBRADA || 0 },
        { clave: 'FACTURADA', label: this.$t('anomaliasRevisar.chipFacturadas'), n: pe.FACTURADA || 0 },
        { clave: 'EJECUTADA', label: this.$t('anomaliasRevisar.chipEjecutadas'), n: pe.EJECUTADA || 0 },
        { clave: 'CERRADA_SAP', label: this.$t('anomaliasRevisar.chipSap'), n: pe.CERRADA_SAP || 0 }
      ];
    },
    // #326 · lo que la tabla de anomalías PUEDE AFIRMAR de lo que está pintando. UNA sola decisión,
    // de la que salen las dos frases que la tabla dice de sí misma: la nota de arriba y el pie de
    // abajo. Si cada una la sacara por su cuenta acabarían diciendo lo contrario, que es el defecto
    // del §9 del CLAUDE.md del orquestador.
    //
    // Habla de las filas que la tabla está PINTANDO: con un chip puesto, las de ese estado. #543: ya
    // no es un subconjunto filtrado en el cliente —el chip filtra en el servidor y «Cargar más» va
    // pidiendo páginas de ESE estado—, así que lo que se pinta es todo lo que se ha cargado y el
    // resumen que lo describe es el `lineasResumen` de la última respuesta, que habla del acumulado.
    // Por lo mismo desaparece el `subconjunto`: aquí cero filas vuelve a demostrar el vacío, porque
    // ningún tope convierte un conjunto con filas en cero filas.
    //
    // Se declara `totalConjunto`: el contador del chip, que NO lleva tope. Un chip en 0 demuestra el
    // vacío, y sin pasarlo la pantalla avisaba de que no podía comprobar la lista justo al lado de un
    // chip diciendo 0 (§9 del CLAUDE.md del orquestador). Ver `totalConjuntoAnomalias`.
    //
    // Misma regla que la cabecera de la tabla de líneas, y por el mismo motivo: dice algo tanto si el
    // servidor concluye que recorta como si NO ha podido concluirlo —un `completitud` DESCONOCIDO, un
    // valor que esta pantalla no conoce, o una API anterior a la #326 que manda la lista sin resumen—.
    // Callar en ese segundo caso dejaba la tabla otra vez sin explicación justo cuando menos se sabe:
    // los chips cuentan el conjunto entero y la tabla enseña una parte.
    estadoAnomalias() {
      const filas = this.anomLineas;
      return ResumenRecorte.estado(this.anomResumen, filas.length,
        filas.reduce(function(s, l) { return s + (l.importe || 0); }, 0),
        { totalConjunto: this.totalConjuntoAnomalias });
    },
    // #543 · el estado del control «Cargar más», decidido en UN sitio: si se puede pulsar y, si no,
    // por qué. Sale de `estadoAnomalias`, la misma decisión de la que sale la nota de los chips, para
    // que las dos partes de la sección no se contradigan (§9 del CLAUDE.md del orquestador).
    cargarMas() {
      if (this.anomCargandoMas || this.anomCargando) {
        return { puede: false, motivo: this.$t('anomaliasRevisar.cargandoMas') };
      }
      // Un fallo no tira lo que ya se ve: el control pasa a «Reintentar» y dice qué pasó. Vale
      // igual para el fallo del chip (página 0) que para el de «Cargar más»: la acción que toca es
      // la misma, reintentar esa página, y así el control no tiene dos formas de contar lo mismo.
      if (this.anomError) {
        return { puede: true, reintentar: true,
                 motivo: this.$t('anomaliasRevisar.cargarMasError', { causa: this.anomError.causa }) };
      }
      // Una página vacía es la prueba de que detrás no queda nada, y es la ÚNICA que hay cuando el
      // servidor no manda un total: sin ella el botón seguía vivo pidiendo páginas vacías. Se dice
      // con sus palabras y no con el «ya se ven todas» del total, que afirmaría algo que aquí no se
      // ha medido —y que podría contradecir a la nota si el total sí vino.
      if (this.anomFin) {
        return { puede: false, motivo: this.$t('anomaliasRevisar.cargarMasFin') };
      }
      const e = this.estadoAnomalias;
      if (e.modo === 'recorta') {
        return { puede: true, motivo: null, quedan: Math.max(0, e.lineas - e.mostradas) };
      }
      // Sin total no se puede afirmar que no quede nada, así que el botón sigue vivo y lo dice: lo
      // que no vale es apagarlo como si estuviera probado que ya están todas.
      if (e.modo === 'sin-total') {
        return { puede: true, motivo: this.$t('anomaliasRevisar.cargarMasSinTotal',
          { causa: ResumenRecorte.MOTIVOS_SIN_TOTAL[e.motivo] || '' }) };
      }
      return { puede: false, motivo: this.anomChip
        ? this.$t('anomaliasRevisar.cargarMasCompleto')
        : this.$t('anomaliasRevisar.cargarMasCompletoTodas') };
    },
    // El rótulo del Exportar de la tabla de líneas, que ahora tiene tres estados que contar: en
    // marcha (con lo que lleva), sobre una selección, o sobre el filtro entero.
    textoExportar() {
      if (this.exportando) {
        return 'Exportando… ' + this.n(this.exportProgreso);
      }
      return this.seleccion.length ? 'Exportar selección' : 'Exportar todo el filtro';
    },
    // El nº de filas del conjunto que la tabla pinta según una fuente SIN TOPE: el contador del chip
    // activo, o el de «Todas» cuando no hay chip. Son los mismos que se pintan en los chips y salen
    // del `$facet` de totales de la MISMA respuesta, así que no hay dos lecturas que cuadrar y un 0
    // aquí no admite otra lectura: no hay nada de ese estado, y por tanto nada que el tope pueda
    // esconder. El módulo solo lee ese cero (ver `ResumenRecorte.estado`): compararlo con las filas
    // para deducir el recorte sería volver a enfrentar dos cifras en la pantalla, que es la familia
    // que cerró la #325.
    //
    // Si el contador no viene como número se devuelve `null` y no un 0: «no lo sé» no puede volverse
    // «no hay nada», que es el defecto de esta tarea del revés. Y por lo mismo NO se usa aquí lo que
    // publican las KPI de arriba (`kpi.lineas`, `agg`): salen de otra llamada, otro instante y otro
    // caché.
    totalConjuntoAnomalias() {
      if (!this.anom) return null;
      const n = this.anomChip
        ? (this.anom.porEstado || {})[this.anomChip]
        : (this.anom.total || {}).n;
      return typeof n === 'number' ? n : null;
    },
    // Va con `totalAparte`: el total de esta sección lo publican los chips y las tres tarjetas, que
    // salen de la MISMA respuesta, así que la nota habla de si la lista está completa y no de un total
    // que falte. Decir «no se ha podido obtener el total» con un chip de 1.240 al lado serían dos
    // partes de la pantalla diciendo lo contrario (§9 del CLAUDE.md del orquestador).
    // Y con las DOS cifras dentro —«se muestran 259 de 4.485»—, que es como lo pidió Dirección en
    // la #543: esta tabla no tiene cabecera de cifras como la de líneas, así que el total solo
    // estaba en el chip, dos controles más arriba, y había que juntar las dos a ojo.
    notaAnomalias() {
      const self = this;
      return ResumenRecorte.nota(self.estadoAnomalias, { totalAparte: true, conTotal: true,
        num: function(v) { return self.n(v); } });
    },
    // Y el pie sale de la MISMA decisión que la nota: «Sin anomalías para el filtro actual.» afirma
    // que no hay nada, y eso con un chip puesto y la página capada no se puede afirmar por el número
    // de filas. Si no está probado, el pie cuenta lo que se enseña y la nota de arriba dice por qué
    // puede no ser todo; lo que no vale es que el pie diga que no hay nada mientras la nota explica
    // que puede haberse quedado fuera (§9 del CLAUDE.md del orquestador).
    // Y con la última carga fallida no se afirma el vacío: sin filas y sin resumen —el caso de un
    // chip cuya primera página no llegó— el módulo concluiría «no hay nada», y lo que hay es que no
    // se sabe. Es la misma regla del módulo: el silencio necesita una prueba, y un fallo no lo es.
    anomaliasVacias() {
      return !this.anomError && ResumenRecorte.estaVacia(this.estadoAnomalias);
    }
  },
  mounted() {
    const self = this;
    ControlPlanificacion.catalogoEstPla().then(function(res) {
      self.catalogo = (res && res.dto) ? res.dto : (res || []);
    }).catch(function() { self.catalogo = []; });
    self.recargar(true);
    self.cargarAnomalias(0);
  },
  methods: {
    // FIX salto de scroll: captura el scrollTop del page-content ANTES de aplicar datos nuevos y lo
    // restaura tras el repintado — aunque la tabla cambie de altura, la vista no se mueve.
    conservarScroll() {
      const self = this;
      const el = self.$el ? self.$el.querySelector('.page-content') : null;
      if (!el) return;
      const top = el.scrollTop;
      self.$nextTick(function() {
        const e2 = self.$el ? self.$el.querySelector('.page-content') : null;
        if (e2) e2.scrollTop = top;
      });
    },
    n(v) { return (v || 0).toLocaleString('es-ES'); },
    eur(v) { return (Math.round(v || 0)).toLocaleString('es-ES') + ' €'; },
    // #860 · horas estimadas (TPCE+TPIE) de la cartera. Con un decimal solo por debajo de 10 h, para
    // que una bolsa pequeña no salga a «0 h» teniendo líneas.
    horas(v) {
      const h = Number(v) || 0;
      return h.toLocaleString('es-ES', { maximumFractionDigits: h < 10 ? 1 : 0 }) + ' h';
    },
    // Las horas solo suman las líneas con tiempo estimado: si falta en alguna se dice, para que la
    // cifra no se lea como completa.
    notaSinTiempo(b) {
      const s = (b && b.lineasSinTiempo) || 0;
      if (!s) return 'líneas activas del filtro';
      return s === 1 ? '1 línea sin tiempo estimado' : this.n(s) + ' líneas sin tiempo estimado';
    },
    pct(a, b) { return b ? Math.round((a / b) * 100) : 0; },
    fecha(d) { return d ? new Date(d).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' }) : '—'; },
    // #857 · la API manda la hora de pared sellada como texto «aaaa-mm-dd hh:mm»: se recorta, no se pasa
    // por Date, que la movería de zona.
    fechaHora(t) {
      const m = /^(\d{4})-(\d{2})-(\d{2})(?: (\d{2}:\d{2}))?/.exec(t || '');
      return m ? m[3] + '/' + m[2] + '/' + m[1] + (m[4] ? ' ' + m[4] : '') : '—';
    },
    textoApartadaDesde(l) {
      if (!l || !l.apartada) return '';
      if (l.apartadaDesdeRegistrada) return this.fechaHora(l.apartadaDesde);
      const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(l.apartadaReferencia || '');
      if (!m) return 'fecha de apartado no registrada';
      return 'apartada desde al menos el ' + m[3] + '/' + m[2] + ' — fecha de apartado anterior no registrada';
    },
    textoApartadaPor(l) {
      if (!l || !l.apartada) return '';
      return l.apartadaPor ? 'por ' + l.apartadaPor : 'usuario no registrado';
    },
    abrirHistorico(l) { this.historicoLinea = l; },
    /** #619 · un instante de la ventana como día completo, «22/10/2021», en el reloj de quien mira. */
    dia(d) { return d ? new Date(d).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '—'; },
    /**
     * #619 · El rango de una ventana en palabras. El `hasta` que viaja es ABIERTO —la medianoche del
     * día siguiente al «Hasta» elegido (ver `ventanaFechas`)—, así que el último día que se ve es el
     * anterior, y es ése el que se nombra: el mismo que la persona escribió en la cabecera.
     */
    textoRango(v) {
      const ultimo = v.hasta ? new Date(new Date(v.hasta).getTime() - 1) : null;
      if (v.desde && ultimo) return 'del ' + this.dia(v.desde) + ' al ' + this.dia(ultimo);
      if (v.desde) return 'desde el ' + this.dia(v.desde);
      return 'hasta el ' + this.dia(ultimo);
    },
    claveLinea(l) { return l.idPedido + '#' + l.numLinea; },
    claseEstPla(valor) { return CLASES_EPLA[valor] || 'e-oth'; },
    filtroComun() {
      return Object.assign({
        provincia: this.filtro.provincia,
        planificable: this.filtro.planificable,
        planificadora: this.filtro.planificadora,
        materia: this.filtro.materia
      }, this.ventanaFechas());
    },
    /**
     * #544 · La ventana de fechas tal como la esperan los TRES endpoints de la pantalla: `{desde,
     * hasta}` como instantes, con el extremo `hasta` ABIERTO. Un solo sitio para los tres, que es lo
     * que garantiza que las cifras de arriba, las tarjetas y las tablas hablen del mismo rango.
     *
     * Con el rango al revés no se manda ventana ninguna, y la nota de al lado del control dice que no
     * se está filtrando por fechas —salvo la ventana por defecto de «Anomalías a revisar» (#619)—. Mandarlo igual cambiaría ese aviso por seis ceros, que se leen
     * como «no hay líneas».
     */
    ventanaFechas() {
      if (this.rangoInvalido) {
        return {};
      }
      const desde = this.instanteDia(this.filtro.desdeStr, 0);
      // El «Hasta» que se elige es un día que SÍ se quiere ver, y la ventana del servidor excluye su
      // extremo derecho: lo que viaja es la medianoche del día SIGUIENTE.
      const hasta = this.instanteDia(this.filtro.hastaStr, 1);
      const out = {};
      if (desde) out.desde = desde;
      if (hasta) out.hasta = hasta;
      return out;
    },
    /**
     * Ronda 1 de revisión de la #544 · la ventana reducida a algo comparable: dos cargas del mismo
     * rango dan la misma cadena. Es con esto con lo que se sabe si las cifras que hay en pantalla son
     * del rango que está puesto, sin tener que comparar objetos a mano en dos sitios.
     */
    claveVentana(v) {
      return (v && v.desde ? v.desde : '') + '|' + (v && v.hasta ? v.hasta : '');
    },
    /**
     * El instante ISO de la medianoche de `ymd` ('AAAA-MM-DD') más `dias`, en el reloj de quien mira
     * la pantalla — que es el del negocio, la misma zona que el módulo sella en el servidor. El
     * desbordamiento de mes y de año lo hace `Date` solo: 31+1 de octubre es el 1 de noviembre.
     */
    instanteDia(ymd, dias) {
      const p = String(ymd || '').split('-');
      if (p.length !== 3) return null;
      // La medianoche se pone con `setFullYear` y no en el constructor: `new Date(85, …)` entiende los
      // años de 0 a 99 como 19xx, y un año de una sola cifra tecleado a mano se iría a 1905 sin que
      // nada lo dijera. El salto de mes y de año lo normaliza igual (31 + 1 de octubre = 1 de
      // noviembre), que es lo que necesita el «Hasta».
      const d = new Date(2000, 0, 1);
      d.setFullYear(Number(p[0]), Number(p[1]) - 1, Number(p[2]) + (dias || 0));
      return isNaN(d.getTime()) ? null : d.toISOString();
    },
    /**
     * #544 · Un cambio en «Desde» o «Hasta» recarga TODA la pantalla, las anomalías incluidas: es lo
     * que impide que las cifras de arriba y las tarjetas de abajo acaben contando rangos distintos.
     *
     * Se recarga TAMBIÉN con el rango al revés, y eso es a propósito: la ventana no viaja (ver
     * `ventanaFechas`) y la nota del control dice que no se está filtrando por fechas (salvo la
     * ventana por defecto de «Anomalías a revisar», #619), así que lo que se ve y lo que se lee
     * coinciden. Quedarse con las cifras de antes parecía más amable, pero
     * dejaba la pantalla en dos verdades a la vez en cuanto se tocaba cualquier otro filtro: cifras
     * sin rango bajo un aviso diciendo que eran las del rango anterior.
     */
    cambioFechas() {
      this.recargar();
      this.cargarAnomalias(0);
    },
    limpiarFechas() {
      this.filtro.desdeStr = null;
      this.filtro.hastaStr = null;
      this.recargar();
      this.cargarAnomalias(0);
    },
    recargar(inicial) {
      const self = this;
      const app = self.$f7;
      self.seleccion = [];
      // PERF (fix 13/08): la TABLA carga EN PARALELO (ms) — no espera a los agregados (que barren
      // 232k líneas y tardan segundos la primera vez; luego caché TTL en backend).
      self.cargarLineas();
      // #663 · Los relojes y las esperas, atados a la sesión: si cambia en vuelo, la frontera calla
      // el `then`/`finally` que los apagaba, y la ruta conserva la instancia para la cuenta siguiente.
      cerrojoDeLaSesion(self, 'cargandoAgg');
      // Mismo testigo que la tabla y las anomalías: dos cambios de filtro seguidos dejaban los
      // recuadros de arriba pintando el primero que contestara, que no es necesariamente el último
      // que se pidió.
      const idAgg = self.nuevaPeticion('agregados');
      self.aggError = null;
      ControlPlanificacion.agregados({ data: self.filtroComun() }).then(function(res) {
        if (!self.vigente('agregados', idAgg)) return;
        self.conservarScroll();
        const d = (res && res.dto) ? res.dto : res;
        const facets = (d && d.agregados) || {};
        self.agg = {
          totales: (facets.totales && facets.totales[0]) || {},
          porEstado: facets.porEstado || [],
          porEstPla: facets.porEstPla || [],
          porPlanificadora: facets.porPlanificadora || [],
          porProvincia: facets.porProvincia || []
        };
        const uno = function(f) { return (facets[f] && facets[f][0]) || { n: 0, importe: 0 }; };
        // Planificadas = estados PLANIFICADA/REALIZADA de porEstado (partición del donut per mockup)
        const planificadas = (facets.porEstado || [])
          .filter(function(e) { return e._id === 'PLANIFICADA' || e._id === 'REALIZADA'; })
          .reduce(function(s, e) { return s + e.n; }, 0);
        self.kpi = {
          lineas: (self.agg.totales.n || 0),
          importe: (self.agg.totales.importe || 0),
          planificables: uno('planificables').n,
          planificadas: planificadas,
          pendientes: uno('pendientes').n,
          noPlanificables: uno('noPlanificables').n,
          importeNoPlan: uno('noPlanificables').importe
        };
        // #860 · llega en la MISMA respuesta que los facets de arriba: no hay dos lecturas que cuadrar.
        const c = d && d.cartera;
        self.cartera = (c && c.total && c.apartada && c.sinApartada) ? c : null;
        self.fichas = (d && d.fichas) || self.fichas;
        self.aggCargado = true;
        if (inicial === true) {
          // Opciones de los selects: del universo SIN filtrar (primera carga)
          self.opciones.planificadoras = (facets.porPlanificadora || []).map(function(e) { return e._id; });
          self.opciones.provincias = (facets.porProvincia || []).map(function(e) { return e._id; }).filter(Boolean);
        }
      }).catch(function(e) {
        if (!self.vigente('agregados', idAgg)) return;
        // Ronda 1 de revisión de la #544 · el mismo olvido que señalaron en las anomalías, en la otra
        // mitad de la pantalla: los seis recuadros, el círculo y las barras se quedaban con las cifras
        // del filtro anterior y el ÚNICO aviso era este diálogo, que se cierra y no deja rastro. Con un
        // rango de fechas recién puesto eso dejaba la pantalla etiquetando las cifras de antes con el
        // rango nuevo para siempre. El diálogo se queda —es el aviso fuerte de la primera carga, cuando
        // no hay cifras que enseñar— y la cabecera lo dice mientras dure.
        self.aggError = self.textoError(e, 'el servidor no ha contestado');
        app.dialog.alert(self.textoError(e, 'No se pudo cargar el dashboard.'));
      }).finally(function() {
        if (!self.vigente('agregados', idAgg)) return;
        self.cargandoAgg = false;
      });
      if (inicial === true) {
        // Materias: catálogo ligero desde las líneas de la primera carga (se rellena en cargarLineas)
        self.opciones.materias = [];
      }
    },
    /**
     * El filtro de la tabla «No planificables por resolver», sin tope ni página: lo que la tabla
     * está mirando ahora mismo. Lo usan la carga y el Exportar, que tienen que hablar del MISMO
     * conjunto — si cada uno lo armara por su cuenta, el CSV acabaría siendo de otro filtro que el
     * que se ve en pantalla (#543).
     */
    filtroTabla() {
      const data = this.filtroComun();
      // La tabla es "no planificables por resolver": si el filtro global Planificable está en Todos,
      // la tabla acota a NO (su misión es resolver bloqueadas); si el usuario fija el filtro, manda él.
      if (data.planificable === null) {
        data.planificable = 'NO';
      }
      if (this.chipActivo) {
        data.estPla = [this.chipActivo];
      }
      return data;
    },
    // Ronda 1 de revisión de la #543 · el mismo olvido que en las anomalías, y en el mismo sitio del
    // módulo: aquí también cambiar de chip o de filtro lanza otra petición sin esperar a la anterior
    // —`setChip` y `recargar` la llaman—, y la que llegaba tarde pisaba las filas de la que sí se
    // está mirando. Y un fallo no decía nada: la tabla se quedaba con las filas del filtro anterior
    // como si fueran las del que se acaba de pedir.
    cargarLineas() {
      const self = this;
      const data = self.filtroTabla();
      data.limite = 300;
      const id = self.nuevaPeticion('lineas');
      cerrojoDeLaSesion(self, 'cargando');
      self.lineasError = null;
      return ControlPlanificacion.lineas({ data: data }).then(function(res) {
        if (!self.vigente('lineas', id)) return;
        self.conservarScroll();
        const d = ((res && res.dto) ? res.dto : res) || {};
        // #326: la respuesta es `{lineas, resumen}`. El array a pelo es la forma ANTERIOR: se acepta
        // para que un despliegue desparejado (front nuevo, API anterior) siga pintando la tabla; sin
        // resumen la cabecera dice que no tiene el total, en vez de rotular la página como si lo fuera.
        const lista = Array.isArray(d) ? d : d.lineas;
        self.lineas = lista || [];
        self.lineasResumen = Array.isArray(d) ? null : (d.resumen || null);
        if (!self.opciones.materias.length) {
          const mats = {};
          self.lineas.forEach(function(l) { if (l.materia) mats[l.materia] = true; });
          self.opciones.materias = Object.keys(mats).sort();
        }
      }).catch(function(e) {
        if (!self.vigente('lineas', id)) return;
        // Se conservan las filas que ya se veían —lo que se ve sigue siendo cierto— y el pie dice de
        // qué consulta son: una tabla que enseña el filtro anterior sin decirlo es la misma clase de
        // mentira que una cifra de página rotulada como total.
        self.lineasError = self.textoError(e, 'el servidor no ha contestado');
      }).finally(function() {
        if (!self.vigente('lineas', id)) return;
        self.cargando = false;
      });
    },
    setChip(valor) {
      this.chipActivo = valor;
      this.seleccion = [];
      this.cargarLineas();
    },
    // ---- PALANCA C FASE 2 + #543: anomalías a revisar (ámbito global; chips y páginas en servidor) ----
    //
    // El chip viaja como `estado` y «Cargar más» como `pagina`. Las tarjetas y los recuentos de los
    // chips vienen en todas las respuestas y son siempre los del conjunto entero (el servidor no les
    // aplica ni el chip ni el tope), así que pulsar un estado no cambia ninguna cifra de la sección.
    cargarAnomalias(pagina) {
      const self = this;
      const mas = (pagina || 0) > 0;
      // El chip con el que se PIDE, no el que esté puesto cuando conteste: entre lo uno y lo otro
      // puede haberse pulsado otro, y entonces esta respuesta ya no es de lo que se está mirando.
      const estado = self.anomChip;
      const id = self.nuevaPeticion('anomalias');
      if (mas) {
        cerrojoDeLaSesion(self, 'anomCargandoMas');
      } else {
        cerrojoDeLaSesion(self, 'anomCargando');
        self.anomFin = false;
      }
      self.anomError = null;
      // #544 · la ventana de fechas viaja también aquí, y por el mismo camino que a /agregados y
      // /lineas: las tres tarjetas y los recuentos de los botones de estado tienen que contar el
      // mismo rango que las cifras de arriba. El resto de los filtros de cabecera sigue sin aplicarse
      // a esta sección (ámbito global adrede), y el rótulo del ámbito lo dice.
      //
      // Ronda 1 de revisión · la ventana se guarda en una variable y no se vuelve a leer del filtro
      // al contestar: es la de ESTA petición, y es la que hay que apuntar junto a las cifras que
      // traiga para poder rotularlas con su rango (ver `anomVentana`).
      const ventana = self.ventanaFechas();
      // #619 · `ventanaPorDefecto` pide al servidor su ventana configurada para cuando la cabecera no
      // trae rango; si lo trae, manda el rango. La fecha la pone el servidor y vuelve en `ventana`.
      const data = Object.assign({
        incluirLineas: true, limite: ANOM_POR_PAGINA, estado: estado, pagina: pagina || 0,
        ventanaPorDefecto: true
      }, ventana);
      return ControlPlanificacion.anomalias({ data: data }).then(function(res) {
        if (!self.vigente('anomalias', id)) return;
        self.conservarScroll();
        const d = ((res && res.dto) ? res.dto : res) || null;
        self.anom = d;
        self.anomVentana = ventana;
        const lista = (d && d.lineas) || [];
        // «Cargar más» AÑADE. El orden del servidor es total y el salto sale de la misma página que
        // se pide, así que concatenar no duplica ni se salta filas.
        self.anomLineas = mas ? self.anomLineas.concat(lista) : lista;
        self.anomResumen = (d && d.lineasResumen) || null;
        self.anomPagina = pagina || 0;
        // Una página vacía prueba el final del recorrido, y es la única prueba que hay cuando el
        // servidor no manda un total con el que concluirlo. Sin ella, «Cargar más» se quedaba vivo
        // en el modo «no se sabe si quedan» y cada pulsación pedía otra página vacía.
        self.anomFin = !lista.length;
      }).catch(function(e) {
        if (!self.vigente('anomalias', id)) return;
        // Las CIFRAS no se tiran: las tarjetas y los contadores de los chips son del conjunto entero
        // y no se enteran del chip, así que siguen valiendo; si se vaciara `anom`, la condición de la
        // sección dejaría de cumplirse y desaparecería entera de la pantalla —sin aviso y sin forma
        // de reintentar ni de elegir otro chip—, que es peor que no haber pulsado. El control dice
        // qué pasó y deja reintentar ESTA página, en vez de quedarse mudo (§9 del CLAUDE.md del
        // orquestador).
        //
        // Ronda 1 de revisión de la #544 · con el rango de fechas eso ya no basta, porque el rango SÍ
        // cambia esas cifras: si lo que falló fue la recarga de un rango nuevo, las que se quedan son
        // las del anterior. `anomVentana` NO se toca aquí a propósito —sigue siendo el rango del que
        // son— y es lo que deja que el rótulo del ámbito y `avisoRangoAnomalias` lo digan, en vez de
        // anunciar el rango nuevo sobre las cifras de antes.
        //
        // Las FILAS sí, y la diferencia es de qué carga falló (ronda 2 de revisión):
        //   · «Cargar más» (página > 0): lo acumulado es de ESTE chip, luego sigue siendo cierto y
        //     se queda; el pie lo cuenta y el botón dice que la última página no llegó.
        //   · el chip (página 0): `setAnomChip` ya ha cambiado `anomChip`, así que lo cargado es del
        //     estado ANTERIOR. Dejarlo pintado enseña filas con su insignia de estado —«Facturada»—
        //     bajo el chip de otro, y la nota diría «se muestran 300 de 5.023» con el chip al lado
        //     diciendo 4.485: dos partes de la pantalla diciendo lo contrario (§9). Se quitan, y el
        //     pie dice por qué la tabla está vacía, que no es lo mismo que decir que no hay nada.
        if (!mas) {
          self.anomLineas = [];
          self.anomResumen = null;
          self.anomPagina = 0;
        }
        self.anomError = { pagina: pagina || 0,
                           causa: self.textoError(e, 'el servidor no ha contestado') };
      }).finally(function() {
        if (!self.vigente('anomalias', id)) return;
        self.anomCargando = false;
        self.anomCargandoMas = false;
      });
    },
    setAnomChip(clave) {
      // Volver a pulsar el chip que ya está puesto no cambia nada: no se paga otra consulta.
      if (this.anomChip === clave) return null;
      this.anomChip = clave;
      return this.cargarAnomalias(0);
    },
    cargarMasAnomalias() {
      if (!this.cargarMas.puede) return null;
      // Tras un fallo se reintenta LA MISMA página que no llegó: la siguiente dejaría un hueco en la
      // lista sin que nada lo dijera.
      return this.cargarAnomalias(this.anomError ? this.anomError.pagina : this.anomPagina + 1);
    },
    /** El número de la petición que se acaba de lanzar para ese flujo (ver `peticiones`). */
    nuevaPeticion(clave) {
      this.peticiones[clave] += 1;
      return this.peticiones[clave];
    },
    /** ¿Sigue siendo esa la última petición lanzada, o ha llegado tarde y ya no se la espera? */
    vigente(clave, id) {
      return this.peticiones[clave] === id;
    },
    /** El mensaje de un error de la API tal como lo rotulan el resto de los métodos de esta pantalla. */
    textoError(e, porDefecto) {
      if (typeof e === 'string') e = { error: e };
      return (e && (e.message || e.error)) || porDefecto;
    },
    claseAnom(ea) { return CLASES_ANOM[ea] || 'b-sap'; },
    labelAnom(ea) {
      const k = { COBRADA: 'badgeCobrada', FACTURADA: 'badgeFacturada',
                  EJECUTADA: 'badgeEjecutada', CERRADA_SAP: 'badgeSap' }[ea];
      return k ? this.$t('anomaliasRevisar.' + k) : (ea || '—');
    },
    estaSeleccionada(l) {
      return this.seleccion.indexOf(this.claveLinea(l)) > -1;
    },
    toggleLinea(l) {
      const k = this.claveLinea(l);
      const i = this.seleccion.indexOf(k);
      if (i > -1) this.seleccion.splice(i, 1); else this.seleccion.push(k);
    },
    seleccionarTodo(e) {
      const self = this;
      self.seleccion = e.target.checked ? self.lineas.map(function(l) { return self.claveLinea(l); }) : [];
    },
    lineasSeleccionadas() {
      const self = this;
      return self.lineas.filter(function(l) { return self.estaSeleccionada(l); });
    },
    refsSeleccionadas() {
      return this.lineasSeleccionadas().map(function(l) {
        return { idPedido: l.idPedido, numLinea: l.numLinea, numeroPedido: l.numeroPedido,
                 codigoPedido: l.codigoPedido, estPlaLabel: l.estPlaLabel, notas: l.estPlaNotas };
      });
    },
    abrirReasignar() {
      this.reasignarValor = null;
      this.reasignarNotas = '';
      this.popupReasignar = true;
    },
    confirmarReasignar() {
      const self = this;
      const app = self.$f7;
      if (!self.reasignarValor) return;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      ControlPlanificacion.reasignarEstPla({ data: {
        lineas: self.refsSeleccionadas(), valor: self.reasignarValor, notas: self.reasignarNotas || null
      } }).then(function(res) {
        const d = (res && res.dto) ? res.dto : res;
        self.popupReasignar = false;
        const errores = (d && d.errores) || [];
        app.toast.create({ text: (d.actualizadas || 0) + ' línea(s) reasignada(s)'
          + (errores.length ? ' · ' + errores.length + ' error(es)' : ''), position: 'center', closeTimeout: 3500 }).open();
        if (errores.length) app.dialog.alert(errores.join('<br>'), 'Errores en la reasignación');
        self.recargar();
      }).catch(function(e) {
        if (typeof e === 'string') e = { error: e };
        app.dialog.alert(e.message || e.error || 'No se pudo reasignar.');
      }).finally(function() { espera.cerrar(); });
    },
    enviarIncidencias() {
      const self = this;
      const app = self.$f7;
      app.dialog.confirm('Se creará una incidencia de planificación por cada línea seleccionada ('
        + self.seleccion.length + '). Las ya enviadas no se duplican. ¿Continuar?', 'Enviar a Incidencias', function() {
        const espera = preloaderDeLaSesion(self);
        espera.mostrar();
        ControlPlanificacion.enviarIncidencias({ data: { lineas: self.refsSeleccionadas() } }).then(function(res) {
          const d = (res && res.dto) ? res.dto : res;
          app.toast.create({ text: (d.incidencias || 0) + ' incidencia(s) registrada(s)', position: 'center', closeTimeout: 3000 }).open();
        }).catch(function(e) {
          if (typeof e === 'string') e = { error: e };
          app.dialog.alert(e.message || e.error || 'No se pudieron enviar.');
        }).finally(function() { espera.cerrar(); });
      });
    },
    /**
     * #543 · Exportar. Con filas marcadas exporta esas, igual que siempre. Sin selección exporta
     * TODO el filtro activo de la tabla y no la página que se está viendo: la tabla carga 300 líneas
     * y el filtro puede tener miles, así que el CSV de antes era el de la página con nombre de
     * informe. El filtro entero se recorre pidiendo páginas de {@code EXPORT_POR_PAGINA} al mismo
     * endpoint que pinta la tabla —el total del conjunto viene en el `resumen` de cada respuesta, y
     * es él quien dice cuándo parar— y sin preloader modal: el botón se apaga, cuenta lo que lleva y
     * la pantalla se sigue pudiendo usar.
     */
    exportarCsv() {
      const self = this;
      const app = self.$f7;
      const seleccionadas = self.lineasSeleccionadas();
      if (seleccionadas.length) {
        self.descargarCsv(seleccionadas);
        return;
      }
      if (self.exportando) return;
      cerrojoDeLaSesion(self, 'exportando');
      self.exportProgreso = 0;
      const data = self.filtroTabla();
      data.limite = EXPORT_POR_PAGINA;
      const todas = [];
      const pedirPagina = function(pagina) {
        data.pagina = pagina;
        return ControlPlanificacion.lineas({ data: Object.assign({}, data) }).then(function(res) {
          const d = ((res && res.dto) ? res.dto : res) || {};
          const lista = (Array.isArray(d) ? d : d.lineas) || [];
          Array.prototype.push.apply(todas, lista);
          self.exportProgreso = todas.length;
          const resumen = Array.isArray(d) ? null : (d.resumen || null);
          const total = (resumen && typeof resumen.total === 'number') ? resumen.total : null;
          // Quién decide que quedan más: el total del conjunto cuando el servidor lo manda y, si no
          // lo manda (API anterior a la #326), que la página haya venido llena. Una página vacía
          // cierra el recorrido en los dos casos: sin esa salida, un total que no cuadrara con lo
          // que devuelve la consulta dejaría el bucle pidiendo páginas para siempre.
          const quedan = lista.length > 0
            && (total === null ? lista.length === EXPORT_POR_PAGINA : todas.length < total);
          if (!quedan) return true;
          if (pagina + 1 >= EXPORT_MAX_PAGINAS) return false;
          return pedirPagina(pagina + 1);
        });
      };
      return pedirPagina(0).then(function(completo) {
        self.descargarCsv(todas);
        if (completo) {
          app.toast.create({ text: self.n(todas.length) + ' líneas exportadas',
            position: 'center', closeTimeout: 3000 }).open();
        } else {
          app.dialog.alert('El filtro tiene más líneas de las que se pueden exportar de una vez: el '
            + 'fichero lleva las ' + self.n(todas.length) + ' primeras, por importe descendente. '
            + 'Acota el filtro para llevártelas todas.', 'Exportación incompleta');
        }
      }).catch(function(e) {
        app.dialog.alert(self.textoError(e, 'No se pudo exportar.'), 'Exportar');
      }).finally(function() {
        self.exportando = false;
      });
    },
    descargarCsv(filas) {
      const esc = function(v) {
        let s = String(v == null ? '' : v);
        // Anti-inyección de fórmulas: Excel ejecuta como fórmula las celdas que empiezan por =,+,-,@
        // (o TAB/CR); el apóstrofo inicial las fuerza a texto.
        if (/^[=+\-@\t\r]/.test(s)) s = "'" + s;
        return '"' + s.replace(/"/g, '""') + '"';
      };
      const cab = ['Pedido', 'Linea', 'Cliente', 'Poblacion', 'Provincia', 'Materia', 'F.Rep.Ejec', 'Importe', 'EST PLA', 'Motivo', 'Apartada desde', 'Apartada por', 'Dias apartada', 'Comentario', 'Estado', 'Planificadora'];
      const self = this;
      const cuerpo = filas.map(function(l) {
        return [l.codigoPedido || l.numeroPedido, l.numLinea, l.cliente, l.poblacion, l.provincia, l.materia,
          l.fRepEjec ? new Date(l.fRepEjec).toLocaleDateString('es-ES') : '', l.importe,
          l.estPlaValor, l.estPlaLabel, self.textoApartadaDesde(l), l.apartada ? (l.apartadaPor || 'no registrado') : '',
          l.apartada && l.diasApartada != null ? l.diasApartada : '',
          l.estPlaNotas, l.estado, l.planificadora].map(esc).join(';');
      });
      const csv = '﻿' + cab.join(';') + '\n' + cuerpo.join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'control-planificacion-' + new Date().toISOString().slice(0, 10) + '.csv';
      a.click();
      URL.revokeObjectURL(a.href);
    },
    irAFichas() {
      this.$f7.views.current.router.navigate('/restricciones/');
    }
  }
};
</script>
